window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.Background_Grey = function() {
	this.initialize(img.MainAssets_Background_Grey);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.Button_disabled = function() {
	this.initialize(img.MainAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_disabled_1 = function() {
	this.initialize(img.MainAssets_Button_disabled_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.MainAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down_1 = function() {
	this.initialize(img.MainAssets_Button_down_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.MainAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up_1 = function() {
	this.initialize(img.MainAssets_Button_up_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Confetti_1 = function() {
	this.initialize(img.MainAssets_Confetti_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1739,1098);


(lib.Confetti_2 = function() {
	this.initialize(img.MainAssets_Confetti_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1733,1089);


(lib.Dashboard = function() {
	this.initialize(img.MainAssets_Dashboard);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1145,434);


(lib.Fade_Topscreen = function() {
	this.initialize(img.MainAssets_Fade_Topscreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,993,408);


(lib.FeedbackPopup_Left = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Left);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.FeedbackPopup_Middle = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Middle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,126,75);


(lib.FeedbackPopup_Right = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Right);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.Finishline = function() {
	this.initialize(img.MainAssets_Finishline);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,806,202);


(lib.Gas = function() {
	this.initialize(img.MainAssets_Gas);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,232,232);


(lib.gatekeeper = function() {
	this.initialize(img.MainAssets_gatekeeper);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1349,2131);


(lib.Hud_1 = function() {
	this.initialize(img.MainAssets_Hud_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,300,345);


(lib.Lane001 = function() {
	this.initialize(img.MainAssets_Lane001);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,1082);


(lib.Lane002 = function() {
	this.initialize(img.MainAssets_Lane002);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,1082);


(lib.Lane003 = function() {
	this.initialize(img.MainAssets_Lane003);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,1082);


(lib.Lane004 = function() {
	this.initialize(img.MainAssets_Lane004);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,1082);


(lib.LaneDividerLine = function() {
	this.initialize(img.MainAssets_LaneDividerLine);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,805,9);


(lib.line1 = function() {
	this.initialize(img.MainAssets_line1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,15,1098);


(lib.MarkerStartBmp = function() {
	this.initialize(img.MainAssets_MarkerStartBmp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,864,120);


(lib.Overlay_Car = function() {
	this.initialize(img.MainAssets_Overlay_Car);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1632,2408);


(lib.Overlay_Speedometer = function() {
	this.initialize(img.MainAssets_Overlay_Speedometer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1632,2409);


(lib.Pattern_02_1000px = function() {
	this.initialize(img.MainAssets_Pattern_02_1000px);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,200,1000);


(lib.Pattern_04_1000px = function() {
	this.initialize(img.MainAssets_Pattern_04_1000px);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,200,1000);


(lib.PrevNextButton = function() {
	this.initialize(img.MainAssets_PrevNextButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_1 = function() {
	this.initialize(img.MainAssets_PrevNextButton_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_disabled = function() {
	this.initialize(img.MainAssets_PrevNextButton_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_disabled_1 = function() {
	this.initialize(img.MainAssets_PrevNextButton_disabled_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_down = function() {
	this.initialize(img.MainAssets_PrevNextButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_down_1 = function() {
	this.initialize(img.MainAssets_PrevNextButton_down_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.Progress_Background = function() {
	this.initialize(img.MainAssets_Progress_Background);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,381,15);


(lib.Progress_Fill = function() {
	this.initialize(img.MainAssets_Progress_Fill);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,381,15);


(lib.Progress_Finish = function() {
	this.initialize(img.MainAssets_Progress_Finish);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,41);


(lib.ProgressDot = function() {
	this.initialize(img.MainAssets_ProgressDot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.ProgressDot_Selected = function() {
	this.initialize(img.MainAssets_ProgressDot_Selected);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.Racing_Illustration = function() {
	this.initialize(img.MainAssets_Racing_Illustration);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,976,2052);


(lib.ResponsivenessBottom = function() {
	this.initialize(img.MainAssets_ResponsivenessBottom);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1145,339);


(lib.ShapeCircle = function() {
	this.initialize(img.MainAssets_ShapeCircle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,128);


(lib.ShapeDiamond = function() {
	this.initialize(img.MainAssets_ShapeDiamond);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,128);


(lib.ShapeStar = function() {
	this.initialize(img.MainAssets_ShapeStar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,128);


(lib.ShapeTriangle = function() {
	this.initialize(img.MainAssets_ShapeTriangle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,150,128);


(lib.Speedometer_Arrow = function() {
	this.initialize(img.MainAssets_Speedometer_Arrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,123);


(lib.Speedometer_Background = function() {
	this.initialize(img.MainAssets_Speedometer_Background);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,260,195);


(lib.Speedometer_Increments = function() {
	this.initialize(img.MainAssets_Speedometer_Increments);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,217,74);


(lib.Speedometer_RingBG = function() {
	this.initialize(img.MainAssets_Speedometer_RingBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,272,201);


(lib.Speedometer_RingFill = function() {
	this.initialize(img.MainAssets_Speedometer_RingFill);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,272,201);


(lib.Speedometer_RingFill_Suboptimal = function() {
	this.initialize(img.MainAssets_Speedometer_RingFill_Suboptimal);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,272,201);


(lib.TutNew01 = function() {
	this.initialize(img.MainAssets_TutNew01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1120,542);


(lib.TutNew02 = function() {
	this.initialize(img.MainAssets_TutNew02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1120,724);


(lib.Woosh_00000 = function() {
	this.initialize(img.MainAssets_Woosh_00000);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00001 = function() {
	this.initialize(img.MainAssets_Woosh_00001);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00002 = function() {
	this.initialize(img.MainAssets_Woosh_00002);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00003 = function() {
	this.initialize(img.MainAssets_Woosh_00003);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00004 = function() {
	this.initialize(img.MainAssets_Woosh_00004);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00005 = function() {
	this.initialize(img.MainAssets_Woosh_00005);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00006 = function() {
	this.initialize(img.MainAssets_Woosh_00006);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00007 = function() {
	this.initialize(img.MainAssets_Woosh_00007);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00008 = function() {
	this.initialize(img.MainAssets_Woosh_00008);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Woosh_Animation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_9 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Woosh_00000();
	this.instance.setTransform(-148.5,-103);

	this.instance_1 = new lib.Woosh_00001();
	this.instance_1.setTransform(-148.5,-103);

	this.instance_2 = new lib.Woosh_00002();
	this.instance_2.setTransform(-148.5,-103);

	this.instance_3 = new lib.Woosh_00003();
	this.instance_3.setTransform(-148.5,-103);

	this.instance_4 = new lib.Woosh_00004();
	this.instance_4.setTransform(-148.5,-103);

	this.instance_5 = new lib.Woosh_00005();
	this.instance_5.setTransform(-148.5,-103);

	this.instance_6 = new lib.Woosh_00006();
	this.instance_6.setTransform(-148.5,-103);

	this.instance_7 = new lib.Woosh_00007();
	this.instance_7.setTransform(-148.5,-103);

	this.instance_8 = new lib.Woosh_00008();
	this.instance_8.setTransform(-148.5,-103);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-148.5,-103,297,206);


(lib.Tween2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot_Selected();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.TutorialStep4Container = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutNew01();
	this.instance.setTransform(0,0,0.6805,0.6805);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep4Container, new cjs.Rectangle(0,0,762.2,368.9), null);


(lib.TutorialStep3Container = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutNew02();
	this.instance.setTransform(0,0,0.6805,0.6805);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep3Container, new cjs.Rectangle(0,0,762.2,492.7), null);


(lib.ShapeTriangleSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShapeTriangle();
	this.instance.setTransform(-75,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShapeTriangleSkin, new cjs.Rectangle(-75,-64,150,128), null);


(lib.ShapeStarSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShapeStar();
	this.instance.setTransform(-75,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShapeStarSkin, new cjs.Rectangle(-75,-64,150,128), null);


(lib.ShapeDiamondSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShapeDiamond();
	this.instance.setTransform(-75,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShapeDiamondSkin, new cjs.Rectangle(-75,-64,150,128), null);


(lib.ShapeCircleSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShapeCircle();
	this.instance.setTransform(-75,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShapeCircleSkin, new cjs.Rectangle(-75,-64,150,128), null);


(lib.SectionDividerSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bar
	this.instance = new lib.LaneDividerLine();
	this.instance.setTransform(-431.85,-4.75,1.0732,1.0647);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SectionDividerSkin, new cjs.Rectangle(-431.8,-4.7,863.8,9.600000000000001), null);


(lib.RoadDividerssidesonly = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1 copy 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EBCzCnbMAAAlO2IBaABMAAAFO2gEhEMCnbMAAAlO2IBaABMAAAFO2g");
	this.shape.setTransform(0,-102.0875);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadDividerssidesonly, new cjs.Rectangle(-436.5,-1173.6,873,2143.1), null);


(lib.RoadTileYellow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Lane003();
	this.instance.setTransform(-108,-1080.85,1,1.0009);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileYellow, new cjs.Rectangle(-108,-1080.8,216,1083), null);


(lib.RoadTileGrey = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Pattern_04_1000px();
	this.instance.setTransform(-108,-1080,1.08,1.081);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#CCC8C9").s().p("EgQ3BUYMAAAiovMAhvAAAMAAACovg");
	this.shape.setTransform(0,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileGrey, new cjs.Rectangle(-108,-1080,216,1081), null);


(lib.RoadTileGreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Lane001();
	this.instance.setTransform(-108,-1080.9,1,1.001);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileGreen, new cjs.Rectangle(-108,-1080.9,216,1083.1000000000001), null);


(lib.RoadTileDarkGrey = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Pattern_02_1000px();
	this.instance.setTransform(-108,-1080,1.08,1.081);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#95918E").s().p("EgQ3BUYMAAAiovMAhvAAAMAAACovg");
	this.shape.setTransform(0,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileDarkGrey, new cjs.Rectangle(-108,-1080,216,1081), null);


(lib.RoadTileBrown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Lane004();
	this.instance.setTransform(-108,-1081.05,1,1.0009);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileBrown, new cjs.Rectangle(-108,-1081,216,1083), null);


(lib.RoadTileBlue = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Lane002();
	this.instance.setTransform(-108,-1080.75,1,1.0009);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileBlue, new cjs.Rectangle(-108,-1080.7,216,1083), null);


(lib.MarkerStart = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg BITMAPS
	this.instance = new lib.MarkerStartBmp();
	this.instance.setTransform(-432,-120.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MarkerStart, new cjs.Rectangle(-432,-120.5,864,120), null);


(lib.RingFill_RED = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Speedometer_RingFill_Suboptimal();
	this.instance.setTransform(-32.5,-24.05,0.239,0.239);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RingFill_RED, new cjs.Rectangle(-32.5,-24,65,48), null);


(lib.ProgressDotTween = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.Overlay_Speedometer_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Overlay_Speedometer();
	this.instance.setTransform(0,0,0.3658,0.3658);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay_Speedometer_1, new cjs.Rectangle(0,0,597.1,881.3), null);


(lib.Overlay_Car_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Overlay_Car();
	this.instance.setTransform(0,0,0.3658,0.3658);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay_Car_1, new cjs.Rectangle(0,0,597.1,881), null);


(lib.Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(47,47,47,0)").ss(4,2,1).p("EhR6iJVMCj1AAAQCCAAAACCMAAAEOnQAACCiCAAMij1AAAQiCAAAAiCMAAAkOnQAAiCCCAAg");
	this.shape.setTransform(673.4667,1052.4837,1.2534,1.1974);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("EhR6CJWQiCAAAAiCMAAAkOnQAAiCCCAAMCj1AAAQCCAAAACCMAAAEOnQAACCiCAAg");
	this.shape_1.setTransform(673.4667,1052.4837,1.2534,1.1974);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay, new cjs.Rectangle(-2,-2,1351,2109), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "23px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.5,-15.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "23px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.5,-15.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "23px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.5,-15.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "23px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.5,-15.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.GateKeeperScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gatekeeper();
	this.instance.setTransform(0,0,0.6204,0.6204);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperScreen, new cjs.Rectangle(0,0,836.9,1322), null);


(lib.Gas_Circle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Gas();
	this.instance.setTransform(-116,-116);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Gas_Circle, new cjs.Rectangle(-116,-116,232,232), null);


(lib.SpeedometerPointer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Speedometer_Arrow();
	this.instance.setTransform(-3.35,-25.85,0.2389,0.2389);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SpeedometerPointer, new cjs.Rectangle(-3.3,-25.8,6.699999999999999,29.400000000000002), null);


(lib.RoadProgressBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_1 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_2 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_3 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_4 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_5 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_6 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_7 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_8 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_9 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_10 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_11 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_12 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_13 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_14 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_15 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_16 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_17 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_18 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_19 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_20 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_21 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_22 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_23 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_24 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_25 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_26 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_27 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_28 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_29 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_30 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_31 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_32 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_33 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_34 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_35 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_36 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_37 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_38 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_39 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_40 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_41 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_42 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_43 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_44 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_45 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_46 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_47 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_48 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_49 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_50 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_51 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_52 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_53 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_54 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_55 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_56 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_57 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_58 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_59 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_60 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_61 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_62 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_63 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_64 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_65 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_66 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_67 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_68 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_69 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_70 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_71 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_72 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_73 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_74 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_75 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_76 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_77 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_78 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_79 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_80 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_81 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_82 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_83 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_84 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_85 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_86 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_87 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_88 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_89 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_90 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_91 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_92 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_93 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_94 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_95 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_96 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_97 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_98 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");
	var mask_graphics_99 = new cjs.Graphics().p("AtRGFIAAsJIajAAIAAMJg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:-159.9503,y:5.8117}).wait(1).to({graphics:mask_graphics_1,x:-158.4446,y:5.8117}).wait(1).to({graphics:mask_graphics_2,x:-156.9389,y:5.8117}).wait(1).to({graphics:mask_graphics_3,x:-155.4332,y:5.8117}).wait(1).to({graphics:mask_graphics_4,x:-153.9275,y:5.8117}).wait(1).to({graphics:mask_graphics_5,x:-152.4222,y:5.8117}).wait(1).to({graphics:mask_graphics_6,x:-150.917,y:5.8117}).wait(1).to({graphics:mask_graphics_7,x:-149.4113,y:5.8117}).wait(1).to({graphics:mask_graphics_8,x:-147.9056,y:5.8117}).wait(1).to({graphics:mask_graphics_9,x:-146.3999,y:5.8117}).wait(1).to({graphics:mask_graphics_10,x:-144.8942,y:5.8117}).wait(1).to({graphics:mask_graphics_11,x:-143.3889,y:5.8117}).wait(1).to({graphics:mask_graphics_12,x:-141.8837,y:5.8117}).wait(1).to({graphics:mask_graphics_13,x:-140.3779,y:5.8117}).wait(1).to({graphics:mask_graphics_14,x:-138.8723,y:5.8117}).wait(1).to({graphics:mask_graphics_15,x:-137.3666,y:5.8117}).wait(1).to({graphics:mask_graphics_16,x:-135.8609,y:5.8117}).wait(1).to({graphics:mask_graphics_17,x:-134.3556,y:5.8117}).wait(1).to({graphics:mask_graphics_18,x:-132.8504,y:5.8117}).wait(1).to({graphics:mask_graphics_19,x:-131.3447,y:5.8117}).wait(1).to({graphics:mask_graphics_20,x:-129.839,y:5.8117}).wait(1).to({graphics:mask_graphics_21,x:-128.3333,y:5.8117}).wait(1).to({graphics:mask_graphics_22,x:-126.8275,y:5.8117}).wait(1).to({graphics:mask_graphics_23,x:-125.3219,y:5.8117}).wait(1).to({graphics:mask_graphics_24,x:-123.817,y:5.8117}).wait(1).to({graphics:mask_graphics_25,x:-122.3114,y:5.8117}).wait(1).to({graphics:mask_graphics_26,x:-120.8057,y:5.8117}).wait(1).to({graphics:mask_graphics_27,x:-119.3,y:5.8117}).wait(1).to({graphics:mask_graphics_28,x:-117.7943,y:5.8117}).wait(1).to({graphics:mask_graphics_29,x:-116.2886,y:5.8117}).wait(1).to({graphics:mask_graphics_30,x:-114.7833,y:5.8117}).wait(1).to({graphics:mask_graphics_31,x:-113.278,y:5.8117}).wait(1).to({graphics:mask_graphics_32,x:-111.7724,y:5.8117}).wait(1).to({graphics:mask_graphics_33,x:-110.2666,y:5.8117}).wait(1).to({graphics:mask_graphics_34,x:-108.761,y:5.8117}).wait(1).to({graphics:mask_graphics_35,x:-107.2553,y:5.8117}).wait(1).to({graphics:mask_graphics_36,x:-105.75,y:5.8117}).wait(1).to({graphics:mask_graphics_37,x:-104.2448,y:5.8117}).wait(1).to({graphics:mask_graphics_38,x:-102.7391,y:5.8117}).wait(1).to({graphics:mask_graphics_39,x:-101.2334,y:5.8117}).wait(1).to({graphics:mask_graphics_40,x:-99.7277,y:5.8117}).wait(1).to({graphics:mask_graphics_41,x:-98.222,y:5.8117}).wait(1).to({graphics:mask_graphics_42,x:-96.7167,y:5.8117}).wait(1).to({graphics:mask_graphics_43,x:-95.2115,y:5.8117}).wait(1).to({graphics:mask_graphics_44,x:-93.7058,y:5.8117}).wait(1).to({graphics:mask_graphics_45,x:-92.2001,y:5.8117}).wait(1).to({graphics:mask_graphics_46,x:-90.6944,y:5.8117}).wait(1).to({graphics:mask_graphics_47,x:-89.1887,y:5.8117}).wait(1).to({graphics:mask_graphics_48,x:-87.683,y:5.8117}).wait(1).to({graphics:mask_graphics_49,x:-86.1782,y:5.8117}).wait(1).to({graphics:mask_graphics_50,x:-84.6725,y:5.8117}).wait(1).to({graphics:mask_graphics_51,x:-83.1668,y:5.8117}).wait(1).to({graphics:mask_graphics_52,x:-81.6611,y:5.8117}).wait(1).to({graphics:mask_graphics_53,x:-80.1554,y:5.8117}).wait(1).to({graphics:mask_graphics_54,x:-78.6497,y:5.8117}).wait(1).to({graphics:mask_graphics_55,x:-77.1444,y:5.8117}).wait(1).to({graphics:mask_graphics_56,x:-75.6392,y:5.8117}).wait(1).to({graphics:mask_graphics_57,x:-74.1335,y:5.8117}).wait(1).to({graphics:mask_graphics_58,x:-72.6278,y:5.8117}).wait(1).to({graphics:mask_graphics_59,x:-71.1221,y:5.8117}).wait(1).to({graphics:mask_graphics_60,x:-69.6164,y:5.8117}).wait(1).to({graphics:mask_graphics_61,x:-68.1111,y:5.8117}).wait(1).to({graphics:mask_graphics_62,x:-66.6059,y:5.8117}).wait(1).to({graphics:mask_graphics_63,x:-65.1002,y:5.8117}).wait(1).to({graphics:mask_graphics_64,x:-63.5945,y:5.8117}).wait(1).to({graphics:mask_graphics_65,x:-62.0888,y:5.8117}).wait(1).to({graphics:mask_graphics_66,x:-60.5831,y:5.8117}).wait(1).to({graphics:mask_graphics_67,x:-59.0778,y:5.8117}).wait(1).to({graphics:mask_graphics_68,x:-57.5726,y:5.8117}).wait(1).to({graphics:mask_graphics_69,x:-56.0669,y:5.8117}).wait(1).to({graphics:mask_graphics_70,x:-54.5612,y:5.8117}).wait(1).to({graphics:mask_graphics_71,x:-53.0555,y:5.8117}).wait(1).to({graphics:mask_graphics_72,x:-51.5498,y:5.8117}).wait(1).to({graphics:mask_graphics_73,x:-50.0441,y:5.8117}).wait(1).to({graphics:mask_graphics_74,x:-48.5393,y:5.8117}).wait(1).to({graphics:mask_graphics_75,x:-47.0336,y:5.8117}).wait(1).to({graphics:mask_graphics_76,x:-45.5279,y:5.8117}).wait(1).to({graphics:mask_graphics_77,x:-44.0222,y:5.8117}).wait(1).to({graphics:mask_graphics_78,x:-42.5165,y:5.8117}).wait(1).to({graphics:mask_graphics_79,x:-41.0108,y:5.8117}).wait(1).to({graphics:mask_graphics_80,x:-39.506,y:5.8117}).wait(1).to({graphics:mask_graphics_81,x:-38.0003,y:5.8117}).wait(1).to({graphics:mask_graphics_82,x:-36.4946,y:5.8117}).wait(1).to({graphics:mask_graphics_83,x:-34.9889,y:5.8117}).wait(1).to({graphics:mask_graphics_84,x:-33.4832,y:5.8117}).wait(1).to({graphics:mask_graphics_85,x:-31.9775,y:5.8117}).wait(1).to({graphics:mask_graphics_86,x:-30.4722,y:5.8117}).wait(1).to({graphics:mask_graphics_87,x:-28.967,y:5.8117}).wait(1).to({graphics:mask_graphics_88,x:-27.4613,y:5.8117}).wait(1).to({graphics:mask_graphics_89,x:-25.9556,y:5.8117}).wait(1).to({graphics:mask_graphics_90,x:-24.4499,y:5.8117}).wait(1).to({graphics:mask_graphics_91,x:-22.9442,y:5.8117}).wait(1).to({graphics:mask_graphics_92,x:-21.4389,y:5.8117}).wait(1).to({graphics:mask_graphics_93,x:-19.9337,y:5.8117}).wait(1).to({graphics:mask_graphics_94,x:-18.428,y:5.8117}).wait(1).to({graphics:mask_graphics_95,x:-16.9223,y:5.8117}).wait(1).to({graphics:mask_graphics_96,x:-15.4166,y:5.8117}).wait(1).to({graphics:mask_graphics_97,x:-13.9109,y:5.8117}).wait(1).to({graphics:mask_graphics_98,x:-12.4056,y:5.8117}).wait(1).to({graphics:mask_graphics_99,x:-10.9004,y:5.8117}).wait(1));

	// fill
	this.instance = new lib.Progress_Fill();
	this.instance.setTransform(-75,-2.85,0.3911,0.39);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(100));

	// bg
	this.instance_1 = new lib.Progress_Background();
	this.instance_1.setTransform(-75,-2.85,0.3911,0.3895);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-75,-2.8,149,5.8);


(lib.FinishTile = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Finishline();
	this.instance.setTransform(-429,-107.5,1.0645,1.0646);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FinishTile, new cjs.Rectangle(-429,-107.5,858,215.1), null);


(lib.Finish = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.finishTextfield = new cjs.Text("FINISH!", "100px 'Roboto Medium'", "#FFFFFF");
	this.finishTextfield.name = "finishTextfield";
	this.finishTextfield.textAlign = "center";
	this.finishTextfield.lineHeight = 122;
	this.finishTextfield.lineWidth = 354;
	this.finishTextfield.parent = this;
	this.finishTextfield.setTransform(1.15,-188.75,3,3);
ranj.TextOffsetFixer.fix(this.finishTextfield);

	this.finishShadowTextfield = new cjs.Text("FINISH!", "100px 'Roboto Medium'", "#8D959E");
	this.finishShadowTextfield.name = "finishShadowTextfield";
	this.finishShadowTextfield.textAlign = "center";
	this.finishShadowTextfield.lineHeight = 122;
	this.finishShadowTextfield.lineWidth = 354;
	this.finishShadowTextfield.alpha = 0.89803922;
	this.finishShadowTextfield.parent = this;
	this.finishShadowTextfield.setTransform(1.15,-172.95,3,3);
ranj.TextOffsetFixer.fix(this.finishShadowTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.finishShadowTextfield},{t:this.finishTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Finish, new cjs.Rectangle(-536.1,-194.7,1074.7,556.4), null);


(lib.EmptyTutorialStep = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.DividerLineDashed = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.line1();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DividerLineDashed, new cjs.Rectangle(0,0,15,1098), null);


(lib.Countdown3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("3", "bold 220px 'Roboto'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 266;
	this.text.lineWidth = 196;
	this.text.parent = this;
	this.text.setTransform(9.8,-416.1,3,3);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("3", "bold 220px 'Roboto'", "#8D959E");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 266;
	this.text_1.lineWidth = 196;
	this.text_1.alpha = 0.89803922;
	this.text_1.parent = this;
	this.text_1.setTransform(9.8,-400.6,3,3);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text_1},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Countdown3, new cjs.Rectangle(-289.9,-422.1,599.4,1190.5), null);


(lib.Countdown2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("2", "bold 220px 'Roboto'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 266;
	this.text.lineWidth = 198;
	this.text.parent = this;
	this.text.setTransform(5,-442.1,3,3);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("2", "bold 220px 'Roboto'", "#8D959E");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 266;
	this.text_1.lineWidth = 198;
	this.text_1.alpha = 0.89803922;
	this.text_1.parent = this;
	this.text_1.setTransform(5,-426.6,3,3);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text_1},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Countdown2, new cjs.Rectangle(-298,-448.1,606.2,1190.5), null);


(lib.Countdown1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("1", "bold 220px 'Roboto'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 266;
	this.text.lineWidth = 198;
	this.text.parent = this;
	this.text.setTransform(3,-441.9,3,3);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("1", "bold 220px 'Roboto'", "#8D959E");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 266;
	this.text_1.lineWidth = 198;
	this.text_1.alpha = 0.89803922;
	this.text_1.parent = this;
	this.text_1.setTransform(3,-426.4,3,3);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text_1},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Countdown1, new cjs.Rectangle(-300,-447.9,606.2,1190.5), null);


(lib.Countdown0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("GO!", "120px 'Roboto Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 146;
	this.text.lineWidth = 238;
	this.text.parent = this;
	this.text.setTransform(13,-214.75,3,3);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("GO!", "120px 'Roboto Medium'", "#8D959E");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 146;
	this.text_1.lineWidth = 238;
	this.text_1.alpha = 0.89803922;
	this.text_1.parent = this;
	this.text_1.setTransform(13,-198.65,3,3);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text_1},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Countdown0, new cjs.Rectangle(-350,-220.7,726.2,662.4), null);


(lib.Confetti2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Confetti_2();
	this.instance.setTransform(-866.5,-3267);

	this.instance_1 = new lib.Confetti_2();
	this.instance_1.setTransform(-866.5,-2178);

	this.instance_2 = new lib.Confetti_2();
	this.instance_2.setTransform(-866.5,-1089);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Confetti2, new cjs.Rectangle(-866.5,-3267,1733,3267), null);


(lib.Confetti1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Confetti_1();
	this.instance.setTransform(-869.5,-3289.5);

	this.instance_1 = new lib.Confetti_1();
	this.instance_1.setTransform(-869.5,-2191.5);

	this.instance_2 = new lib.Confetti_1();
	this.instance_2.setTransform(-869.5,-1093.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Confetti1, new cjs.Rectangle(-869.5,-3289.5,1739,3294), null);


(lib.TutorialButtonHitarea_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea_1, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.FeedbackPopupBG_Right = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Right();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Right, new cjs.Rectangle(0,0,50,75), null);


(lib.FeedbackPopupBG_Middle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Middle();
	this.instance.setTransform(-2,0,1.0482,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Middle, new cjs.Rectangle(-2,0,132.1,75), null);


(lib.FeedbackPopupBG_Left = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Left();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Left, new cjs.Rectangle(0,0,50,75), null);


(lib.StartTutorialButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "19px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 23;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.3,-13.8);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "19px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 23;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.3,-13.8);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "19px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 23;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.3,-13.8);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "19px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 23;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.3,-13.8);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.StartGameButton_Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 19;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 19;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 19;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 19;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up_1();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down_1();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled_1();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.StartGameButton_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField_1 = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField_1.name = "upLabelTextField_1";
	this.upLabelTextField_1.textAlign = "center";
	this.upLabelTextField_1.lineHeight = 26;
	this.upLabelTextField_1.lineWidth = 146;
	this.upLabelTextField_1.parent = this;
	this.upLabelTextField_1.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField_1);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField_1).wait(4));

	// Text Over
	this.overLabelTextField_1 = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField_1.name = "overLabelTextField_1";
	this.overLabelTextField_1.textAlign = "center";
	this.overLabelTextField_1.lineHeight = 26;
	this.overLabelTextField_1.lineWidth = 146;
	this.overLabelTextField_1.parent = this;
	this.overLabelTextField_1.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField_1);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField_1).wait(4));

	// Text Down
	this.downLabelTextField_1 = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField_1.name = "downLabelTextField_1";
	this.downLabelTextField_1.textAlign = "center";
	this.downLabelTextField_1.lineHeight = 26;
	this.downLabelTextField_1.lineWidth = 146;
	this.downLabelTextField_1.parent = this;
	this.downLabelTextField_1.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField_1);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField_1).wait(4));

	// Text Disabled
	this.disabledLabelTextField_1 = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField_1.name = "disabledLabelTextField_1";
	this.disabledLabelTextField_1.textAlign = "center";
	this.disabledLabelTextField_1.lineHeight = 26;
	this.disabledLabelTextField_1.lineWidth = 146;
	this.disabledLabelTextField_1.alpha = 0.49803922;
	this.disabledLabelTextField_1.parent = this;
	this.disabledLabelTextField_1.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField_1);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField_1).wait(4));

	// Button
	this.instance_3 = new lib.Button_up_1();
	this.instance_3.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_4 = new lib.Button_down_1();
	this.instance_4.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_5 = new lib.Button_disabled_1();
	this.instance_5.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3}]}).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.BottomBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ResponsivenessBottom();
	this.instance.setTransform(-682.7,-125,1.179,1.179);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BottomBar, new cjs.Rectangle(-682.7,-125,1350,399.7), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Racing_Illustration();
	this.instance.setTransform(-667,-1445,1.3669,1.367);

	this.instance_1 = new lib.Background_Blue();
	this.instance_1.setTransform(-667,-1286,1.3655,1.3655);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667,-1445,1334.1,2961), null);


(lib.TutorialStep5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(4,1,1).p("A+J4wMA8TAAAQDIAAAADIMAAAArRQAADIjIAAMg8TAAAQjIAAAAjIMAAAgrRQAAjIDIAAg");
	this.shape.setTransform(57.6,-355.65);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,1,1).p("AAAukIAAdJ");
	this.shape_1.setTransform(-68.1,-113.141,1,0.9115);

	this.bodyTextfield = new cjs.Text("Try to keep the number of moves you make in a level to a minimum.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 676;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-289.05,11.548);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.actionTextfield = new cjs.Text("Press to continue", "italic 38px 'Roboto'", "#CCCCCC");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.textAlign = "right";
	this.actionTextfield.lineHeight = 46;
	this.actionTextfield.lineWidth = 691;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(386.6,379.3479);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.instance = new lib.TutorialStep3Container();
	this.instance.setTransform(-0.05,125,1,1,0,0,0,330.8,153.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.actionTextfield},{t:this.bodyTextfield},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep5, new cjs.Rectangle(-330.8,-516.1,762.2,980.4000000000001), null);


(lib.TutorialStep4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#262324").s().p("Ai6C8QhOhOAAhuQAAhtBOhNQBNhOBtAAQBuAABNBOQBOBNAABtQAABuhOBOQhNBNhuAAQhtAAhNhNg");
	this.shape.setTransform(258.5,316.55);

	this.bodyTextfield = new cjs.Text("Change your lane and see how your speed would change.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 454;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-228.7,-162.1527);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape_1.setTransform(108.3,188.4789,1,0.2886);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#262324").ss(4,2,1).p("ASXAAMgktAAA");
	this.shape_2.setTransform(176.7585,316.55,0.5788,1);

	this.instance = new lib.TutorialStep4Container();
	this.instance.setTransform(-65.35,-110.15,0.6884,0.6884,0,0,0,290.1,118.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_2},{t:this.shape_1},{t:this.bodyTextfield},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep4, new cjs.Rectangle(-265,-191.6,550,534.7), null);


(lib.TutorialStep3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.actionTextfield = new cjs.Text("Press to continue", "italic 38px 'Roboto'", "#CCCCCC");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.textAlign = "right";
	this.actionTextfield.lineHeight = 46;
	this.actionTextfield.lineWidth = 691;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(119.45,-584.9021);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(4,1,1).p("A+J4wMA8TAAAQDIAAAADIMAAAArRQAADIjIAAMg8TAAAQjIAAAAjIMAAAgrRQAAjIDIAAg");
	this.shape.setTransform(-225,-1327.5);

	this.bodyTextfield = new cjs.Text("The speedometer shows how fast you are going.\n\nYour speed is determined by the lane you are in.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 668;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-548.45,-958.05);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,1,1).p("AAAukIAAdJ");
	this.shape_1.setTransform(-350.7,-1084.991,1,0.9115);

	this.instance = new lib.TutorialStep3Container();
	this.instance.setTransform(-328.7,-895.85,1,1,0,0,0,265.9,103);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_1},{t:this.bodyTextfield},{t:this.shape},{t:this.actionTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep3, new cjs.Rectangle(-594.6,-1488,762.2,981.9), null);


(lib.TutorialStep2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#262324").s().p("Ai6C8QhOhOAAhuQAAhtBOhNQBNhOBtAAQBuAABNBOQBOBNAABtQAABuhOBOQhNBNhuAAQhtAAhNhNg");
	this.shape.setTransform(401.5,291.5);

	this.bodyTextfield = new cjs.Text("You control the orange race car.\n\nYou can switch lanes by clicking the lane you want to move to.\n", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 663;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-324.4,-443.0521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#262324").ss(4,1,1).p("EAAAhFAMAAACKB");
	this.shape_1.setTransform(233.3,82.7042,1,0.4732);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#262324").ss(4,2,1).p("ASXAAMgktAAA");
	this.shape_2.setTransform(311.6042,292,0.6595,1);

	this.instance = new lib.TutorialStep4Container();
	this.instance.setTransform(-61.15,-378.6,1,1,0,0,0,316.7,116.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_2},{t:this.shape_1},{t:this.bodyTextfield},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep2, new cjs.Rectangle(-377.8,-495,805.8,813), null);


(lib.TutorialStep1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.actionTextfield = new cjs.Text("Press to continue", "italic 38px 'Roboto'", "#CCCCCC");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.textAlign = "right";
	this.actionTextfield.lineHeight = 46;
	this.actionTextfield.lineWidth = 647;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(76.15,-622.1021);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.bodyTextfield = new cjs.Text("The speedometer shows how fast you are going.\n\nYour speed is determined by the lane you are in.", "40px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 628;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-548.45,-958.05);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.TutorialStep3Container();
	this.instance.setTransform(-339.5,-894.3,0.9201,0.9201,0,0,0,265.9,103);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.bodyTextfield},{t:this.actionTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep1, new cjs.Rectangle(-584.1,-989,701.3000000000001,453.29999999999995), null);


(lib.RoadTileSeparator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DividerLineDashed();
	this.instance.setTransform(1.5,-538,1,1,0,0,0,8.5,542);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileSeparator, new cjs.Rectangle(-216,-1080,432,1098), null);


(lib.ProgressDot_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {unselected:0,selected:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop()
	}
	this.frame_23 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(23).call(this.frame_23).wait(1));

	// Layer_1
	this.instance = new lib.ProgressDotTween("synched",0);
	this.instance.setTransform(0,0,0.9677,0.9677);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.3226,scaleY:1.3226},23).wait(1));

	// Layer_4
	this.instance_1 = new lib.Tween2("synched",0);
	this.instance_1.setTransform(0,0,0.6452,0.6452);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.2903,scaleY:1.2903,alpha:1},23).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.4,-20.4,41,41);


(lib.GatekeeperBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GateKeeperScreen();
	this.instance.setTransform(418.4,661,1,1,0,0,0,418.4,661);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GatekeeperBackground, new cjs.Rectangle(0,0,836.9,1322), null);


(lib.Gas_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Gas6 copy
	this.instance = new lib.Gas_Circle();
	this.instance.setTransform(-4,-137.25,0.13,0.13,0,0,0,0,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regY:0,scaleX:1,scaleY:1,x:130.85,y:302.3},197).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).wait(2));

	// Gas5 copy
	this.instance_1 = new lib.Gas_Circle();
	this.instance_1.setTransform(-18.75,-81.5,0.2404,0.2404,0,0,0,-0.2,-0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({regX:0,regY:0,scaleX:1,scaleY:1,x:-120,y:302.3},172).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({scaleX:0.2363,scaleY:0.2363,x:-18.2,y:-83.6},26).wait(1));

	// Gas4 copy
	this.instance_2 = new lib.Gas_Circle();
	this.instance_2.setTransform(-4,-26.25,0.3497,0.3497,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regY:0,scaleX:1,scaleY:1,y:302.3},148).to({regY:-0.4,scaleX:0.13,scaleY:0.13,y:-137.25},1).to({regX:-0.1,regY:-0.5,scaleX:0.3454,scaleY:0.3454,x:-4.05,y:-28.45},50).wait(1));

	// Gas6
	this.instance_3 = new lib.Gas_Circle();
	this.instance_3.setTransform(47.05,29.15,0.4595,0.4595,0,0,0,0,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regY:0,scaleX:1,scaleY:1,x:130.85,y:302.3},123).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({regX:0.1,scaleX:0.4552,scaleY:0.4552,x:46.35,y:26.95},75).wait(1));

	// Gas5
	this.instance_4 = new lib.Gas_Circle();
	this.instance_4.setTransform(-62.6,84.65,0.5694,0.5694,0,0,0,0,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regY:0,scaleX:1,scaleY:1,x:-120,y:302.3},98).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({regX:-0.1,scaleX:0.565,scaleY:0.565,x:-62.05,y:82.4},100).wait(1));

	// Gas4
	this.instance_5 = new lib.Gas_Circle();
	this.instance_5.setTransform(-4,138.85,0.6765,0.6765,0,0,0,0,-0.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({regY:0,scaleX:1,scaleY:1,y:302.3},74).to({regY:-0.4,scaleX:0.13,scaleY:0.13,y:-137.25},1).to({regX:-0.1,scaleX:0.6721,scaleY:0.6721,x:-4.05,y:136.6},124).wait(1));

	// Gas3
	this.instance_6 = new lib.Gas_Circle();
	this.instance_6.setTransform(97.6,194.05,0.7858,0.7858,0,0,0,0,-0.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({regY:0,scaleX:1,scaleY:1,x:130.85,y:302.3},49).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({scaleX:0.7814,scaleY:0.7814,x:96.85,y:191.8},149).wait(1));

	// Gas2
	this.instance_7 = new lib.Gas_Circle();
	this.instance_7.setTransform(-106.1,249.25,0.8951,0.8951,0,0,0,-0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).to({regX:0,regY:0,scaleX:1,scaleY:1,x:-120,y:302.3},24).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({scaleX:0.8907,scaleY:0.8907,x:-105.5,y:247.05},174).wait(1));

	// Gas1
	this.instance_8 = new lib.Gas_Circle();
	this.instance_8.setTransform(-4,302.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({regY:-0.4,scaleX:0.13,scaleY:0.13,y:-137.25},1).to({regX:-0.1,scaleX:0.9956,scaleY:0.9956,x:-4.1,y:300},198).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-236,-152.3,482.9,570.6);


(lib.Speedometer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pointer
	this.pointer = new lib.SpeedometerPointer();
	this.pointer.name = "pointer";
	this.pointer.setTransform(-0.95,6.65,1,1,-119.9992,0,0,-0.1,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.pointer).to({regY:0.1,rotation:-58.001,x:-1,y:6.7},29).to({regX:0,regY:0,rotation:0,y:6.65},30).to({rotation:58,x:-0.95},30).to({rotation:119.9999,x:-1},30).wait(1));

	// circle as fill (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AjoBlIAAAAQgggggWglIAjgUQATAgAcAdQBWBVB3AAQB4AABVhVQAbgcATgeIAjAUQgWAjgeAfIAAAAQhhBhiJAAQiIAAhhhhg");
	var mask_graphics_1 = new cjs.Graphics().p("AgEDGQiJgFhehkIAAgBQgeghgUgmIAjgSQASAhAbAdQBSBZB4AEQB3AEBZhSQAcgbATgdIAjAVQgXAiggAeIAAAAQhfBZiBAAIgMAAg");
	var mask_graphics_2 = new cjs.Graphics().p("AgKDFQiJgJhZhoIAAgBQgegigTgmIAkgQQARAgAaAeQBPBcB4AIQB3AJBbhPQAdgaAUgdIAiAXQgYAighAcIAAAAQhdBRh5AAIgZgBg");
	var mask_graphics_3 = new cjs.Graphics().p("AgQDEQiIgOhWhrIAAgBQgdgjgRgnIAlgPQAPAhAZAfQBMBfB3AMQB3ANBehMQAegYAVgcIAhAYQgZAggiAcIAAgBQhbBKhxAAQgTAAgTgCg");
	var mask_graphics_4 = new cjs.Graphics().p("AgWDDQiHgUhThuIABAAQgcglgQgmIAmgOQAOAhAYAgQBIBhB3ARQB2ARBhhIQAegYAXgbIAgAZQgbAggiAaIAAAAQhZBChqAAQgZAAgZgDg");
	var mask_graphics_5 = new cjs.Graphics().p("AgcDBQiGgZhPhwIABgBQgaglgPgnIAmgNQANAiAXAhQBEBjB3AVQB1AWBjhFQAfgWAYgbIAfAaQgbAfgkAZIAAgBQhWA8hjAAQgfAAgfgFg");
	var mask_graphics_6 = new cjs.Graphics().p("AghC+QiGgdhKhzIAAgBQgZgmgNgoIAmgLQAMAjAWAhQBBBmB1AZQB0AaBmhBQAggWAZgZIAeAbQgdAegkAXIAAAAQhTA2hdAAQgkAAgkgJg");
	var mask_graphics_7 = new cjs.Graphics().p("AgnC8QiFgihGh2IAAgBQgXgmgLgpIAmgKQALAkAUAhQA+BoB0AeQBzAeBog+QAhgUAagZIAcAdQgdAcglAXIAAgBQhQAwhWAAQgqAAgqgLg");
	var mask_graphics_8 = new cjs.Graphics().p("AgtC4QiDgmhCh5IAAAAQgVgngLgqIAngIQAJAkAUAiQA5BqBzAiQBzAiBqg6QAhgTAbgYIAcAeQgfAbgmAVIAAAAQhMAqhQAAQgvAAgwgPg");
	var mask_graphics_9 = new cjs.Graphics().p("AgyC1QiCgsg+h6IAAgBQgUgogIgpIAngIQAHAlASAkQA2BrByAmQBxAmBsg2QAjgSAbgXIAaAfQgfAagnAUIAAgBQhIAlhKAAQg1AAg0gSg");
	var mask_graphics_10 = new cjs.Graphics().p("Ag4CxQiAgwg5h9IAAgBQgTgogHgqIAngGQAHAlAQAkQAzBtBwAqQBvAqBugyQAjgQAcgWIAaAfQggAagoASIAAAAQhEAfhFAAQg6AAg5gWg");
	var mask_graphics_11 = new cjs.Graphics().p("Ag+CsQh+g0g0h+IAAAAQgRgqgGgrIAngEQAGAlAPAlQAuBuBvAvQBuAuBvgvQAkgPAdgVIAYAhQghAYgoARIAAgBQhAAbg/AAQg/AAg/gbg");
	var mask_graphics_12 = new cjs.Graphics().p("AhDCoQh9g5gviAIAAAAQgQgrgEgqIAogEQAEAlAOAmQAqBwBtAyQBsAyBxgqQAkgOAegUIAXAiQgiAXgpAPIAAAAQg7AWg6AAQhEAAhDgfg");
	var mask_graphics_13 = new cjs.Graphics().p("AhICjQh7g+griBIAAgBQgOgrgCgqIAngCQADAlAMAmQAmByBsA2QBqA2BzgmQAkgNAegTIAWAiQgiAWgqAOIABAAQg3ASg0AAQhKAAhHgkg");
	var mask_graphics_14 = new cjs.Graphics().p("AhOCdQh4hCgmiCIAAgBQgNgrgBgrIAoAAQABAlAMAmQAhBzBqA6QBoA6B0giQAlgLAfgSIAVAjQgkAUgqANIABgBQgxAPgwAAQhPAAhMgqg");
	var mask_graphics_15 = new cjs.Graphics().p("AhTCXQh1hGgiiEIAAAAQgLgsABgrIAnABQAAAmAKAmQAeB1BnA9QBmA9B1gdQAlgKAggRIATAkQgkATgqALIAAgBQgrAMgqAAQhVAAhQgwg");
	var mask_graphics_16 = new cjs.Graphics().p("AhYCRQhzhKgdiFIABgBQgKgsACgrIAoADQgCAlAJAnQAZB2BlBBQBkBBB2gaQAmgIAggQIASAkQglASgqAKIAAgBQgmAIglAAQhbAAhTg1g");
	var mask_graphics_17 = new cjs.Graphics().p("AhcCLQhwhPgZiGIABAAQgIgtADgqIAoAEQgDAlAHAnQAVB2BjBFQBhBEB3gVQAmgHAhgOIARAlQgmAQgrAIIABgBQghAGgfAAQhhAAhWg7g");
	var mask_graphics_18 = new cjs.Graphics().p("AhgCEQhuhTgTiGIAAgBQgGgtAFgqIAnAFQgEAlAGAoQARB3BgBIQBfBIB3gRQAngGAhgNIAPAlQgmAPgrAHIAAgBQgaAEgZAAQhpAAhYhCg");
	var mask_graphics_19 = new cjs.Graphics().p("AhkB9QhrhXgOiHIAAAAQgEguAGgqIAnAHQgFAlAEAoQANB3BdBMQBcBLB5gNQAmgEAhgMIAPAmQgnANgrAFIAAAAQgUACgTAAQhwAAhbhJg");
	var mask_graphics_20 = new cjs.Graphics().p("AhoB1QhnhagKiIIABAAQgDgtAIgqIAnAIQgHAlADAnQAIB4BbBPQBZBPB5gJQAmgDAigLIANAnQgnAMgsAEIABgBIgbABQh4AAhdhRg");
	var mask_graphics_21 = new cjs.Graphics().p("ACCDLQiJAFhkheQhkhdgEiIIAAgBQgBgtAJgpIAnAJQgIAkABAoQAEB4BYBSQBWBSB5gEQAngBAigKIALAnQgnALgsABg");
	var mask_graphics_22 = new cjs.Graphics().p("AB8DRQiJAAhghhQhhhhAAiIIABgBQAAgtALgpIAmALQgJAkAAAoQgBB5BVBUQBUBVB4AAQAnAAAjgJIAKAoQgoAJgsAAg");
	var mask_graphics_23 = new cjs.Graphics().p("AB1DXIABgBQiJgEhdhlQhdhkAFiJIABAAQABgtANgpIAmAMQgLAkgBAoQgFB5BRBXQBSBYB4AFQAmABAjgHIAJAnQgiAHglAAIgNAAg");
	var mask_graphics_24 = new cjs.Graphics().p("ABvDcIABgBQiIgJhahoQhZhoAKiIIAAAAQAEgtANgpIAmAOQgMAjgDAoQgJB5BOBaQBPBbB3AJQAnACAjgGIAHAoQgcAFgdAAIgbgBg");
	var mask_graphics_25 = new cjs.Graphics().p("ABpDgIABAAQiIgPhWhrQhVhqAPiIIAAAAQAFguAQgnIAlAPQgOAjgEAnQgNB5BLBcQBLBeB3ANQAmAEAkgFIAFAoQgVADgXAAQgTAAgVgCg");
	var mask_graphics_26 = new cjs.Graphics().p("ABkDkIAAAAQiHgUhShuQhShtAUiHIABgBQAGgtARgnIAkAQQgOAjgGAnQgRB4BHBfQBIBhB2ARQAnAFAjgDIAFAoIggACQgaAAgagEg");
	var mask_graphics_27 = new cjs.Graphics().p("ABeDnIAAAAQiGgYhOhxQhOhwAZiHIABAAQAIgtASgmIAkARQgQAigHAoQgWB2BEBiQBEBjB2AWQAmAGAkgCIADApIgTAAQggAAghgGg");
	var mask_graphics_28 = new cjs.Graphics().p("ABYDqIABAAQiGgdhJh0QhKhyAeiGIAAAAQAKgtATgmIAjATQgQAhgJAoQgaB2BABkQBBBlB1AaQAmAIAjgBIACApIgGAAQgmAAgogJg");
	var mask_graphics_29 = new cjs.Graphics().p("ABODtIAAgBQiEgihGh2QhFh1AiiFIABAAQALgsAVglIAiAUQgSAhgKAnQgeB1A9BmQA9BnB0AfQAlAJAkAAIAAApQgpgBgqgKg");
	var mask_graphics_30 = new cjs.Graphics().p("ABCDvIABgBQiDgmhBh5QhCh3AniEIABAAQANgsAWgkIAiAVQgUAggLAnQgiB0A5BoQA5BqBzAiQAlALAjABIgBApQgpgCgqgMg");
	var mask_graphics_31 = new cjs.Graphics().p("AA3DwIABAAQiCgrg9h7Qg9h6AsiCIAAAAQAPgrAXgkIAhAXQgUAfgNAmQgmBzA1BqQA1BsByAmQAlAMAjADIgDApQgogEgqgOg");
	var mask_graphics_32 = new cjs.Graphics().p("AAsDyIAAAAQh/gxg5h8Qg4h8AwiBIAAAAQARgqAYgjIAgAYQgVAegOAmQgrBxAyBsQAxBtBwArQAkANAkAFIgEAoQgpgFgpgPg");
	var mask_graphics_33 = new cjs.Graphics().p("AAhDzIAAAAQh+g1g0h/Qg0h+A1h+IABAAQASgqAZgiIAgAZQgXAegPAkQgvBwAtBuQAuBvBuAvQAkAOAjAGIgFAoQgpgHgogQg");
	var mask_graphics_34 = new cjs.Graphics().p("AAWD0IABAAQh8g6gwiAQgviAA5h8IABgBQATgpAbghIAeAaQgXAdgRAkQgzBuAqBwQApBwBtAzQAjAQAjAHIgHAoQgogIgogSg");
	var mask_graphics_35 = new cjs.Graphics().p("AALD0IABAAQh6g+griCQgriBA+h6IABgBQAUgoAdggIAdAbQgZAcgSAkQg2BsAlBxQAmByBrA2QAiARAjAIIgJAoQgogJgngUg");
	var mask_graphics_36 = new cjs.Graphics().p("AABD0IAAAAQh3hCgmiDQgmiDBCh4IAAAAQAWgoAegfIAcAcQgaAbgTAjQg6BqAhByQAhB0BpA6QAiASAjAKIgKAnQgogLgmgVg");
	var mask_graphics_37 = new cjs.Graphics().p("AgID0IAAAAQh2hGghiFQgiiEBHh2IAAAAQAYgnAegeIAbAdQgaAbgVAiQg+BoAdBzQAeB0BmA/QAiATAiALIgMAnQgngNgkgWg");
	var mask_graphics_38 = new cjs.Graphics().p("AgTD0IABAAQh0hLgciGQgdiFBLhzIAAAAQAZgmAggdIAaAeQgcAZgVAiQhCBlAZB1QAZB1BkBCQAhAVAiALIgNAnQgngOgkgXg");
	var mask_graphics_39 = new cjs.Graphics().p("AgcDzIAAAAQhxhPgYiHQgXiGBOhwIABAAQAaglAhgcIAZAfQgdAYgXAhQhFBjAVB1QAVB3BjBFQAeAWAiANIgOAmQgngPgigZg");
	var mask_graphics_40 = new cjs.Graphics().p("AgmDyIAAAAQhuhTgSiIQgTiGBShuIABAAQAbgkAigaIAYAfQgdAYgZAgQhIBgAQB2QARB3BgBJQAeAXAhAOIgQAlQgkgQgjgag");
	var mask_graphics_41 = new cjs.Graphics().p("AgwDwIABAAQhrhWgOiIQgOiIBXhqIAAAAQAdgjAigZIAXAgQgeAWgZAfQhMBeAMB3QAMB3BeBMQAdAYAgAPIgRAlQgjgRgjgcg");
	var mask_graphics_42 = new cjs.Graphics().p("Ag5DvIABAAQhohbgJiIQgJiIBahnIABAAQAegiAjgYIAWAhQgfAVgbAeQhPBbAIB3QAIB4BbBPQAdAaAfAQIgSAkQgkgTghgcg");
	var mask_graphics_43 = new cjs.Graphics().p("AhBDtIAAAAQhkhegFiJQgEiIBehkIABAAQAfghAkgXIATAiQgeAUgcAeQhSBYADB3QAEB4BYBSQAdAbAeARIgUAkQgigVgggdg");
	var mask_graphics_44 = new cjs.Graphics().p("AhKDqIABAAQhhhhAAiJQABiIBhhhIABAAQAggfAlgWIASAjQgfATgcAcQhWBVgBB3QAAB4BVBWQAbAbAdATIgTAjQgjgWgfgfg");
	var mask_graphics_45 = new cjs.Graphics().p("AhSDoIAAAAQhdhlAFiIQAGiJBlhdIAAAAQAigfAkgTIATAjQggASgeAbQhZBSgFB4QgEB3BRBYQAbAdAdATIgVAiQgigWgeggg");
	var mask_graphics_46 = new cjs.Graphics().p("AhaDlIABAAQhahoAKiIQALiIBohaIAAAAQAjgdAlgTIARAkQgiARgdAaQhcBPgJB3QgJB3BPBcQAZAdAdAUIgXAiQghgYgdghg");
	var mask_graphics_47 = new cjs.Graphics().p("AhhDiIAAAAQhWhsAPiHQAQiIBrhVIAAAAQAkgdAmgRIAPAlQgiAPgeAZQheBMgOB3QgNB2BLBfQAYAeAdAVIgZAhQgggZgbgig");
	var mask_graphics_48 = new cjs.Graphics().p("AhpDeIABAAQhShuAUiHQAUiHBuhSIABAAQAkgbAngPIAOAlQgiAOggAYQhhBIgRB2QgSB2BIBhQAXAfAbAXIgZAfQgfgagbgjg");
	var mask_graphics_49 = new cjs.Graphics().p("AhvDaIAAAAQhOhxAZiFQAZiHBxhOIABAAQAkgZAogPIANAmQgjANggAXQhkBEgWB2QgWB1BFBkQAWAfAaAYIgaAfQgegcgZgkg");
	var mask_graphics_50 = new cjs.Graphics().p("Ah2DWIABAAQhKhzAdiFQAeiGB0hJIABAAQAlgZApgMIALAmQgkALghAWQhlBAgbB2QgaB0BBBmQAVAgAaAZIgcAdQgdgcgYglg");
	var mask_graphics_51 = new cjs.Graphics().p("Ah8DSIAAAAQhFh2AiiEQAjiEB2hGIABAAQAmgXApgLIAKAnQgkAKgiAUQhoA9geB0QgeBzA9BpQAUAhAYAZIgcAdQgdgegWglg");
	var mask_graphics_52 = new cjs.Graphics().p("AiCDNIABABQhCh5AniDQAoiDB4hBIAAAAQAogVAqgKIAIAnQgkAJgjATQhqA5giBzQgjByA6BqQASAiAYAbIgeAbQgbgegVgng");
	var mask_graphics_53 = new cjs.Graphics().p("AiHDJIAAAAQg9h7AsiBQAsiCB6g9IABABQAogVAqgIIAHAnQgkAIgkARQhrA2gnByQgnBwA2BtQARAiAXAbIgeAbQgbgfgTgng");
	var mask_graphics_54 = new cjs.Graphics().p("AiMDDIAAABQg4h+Awh/QAxiAB8g4IAAAAQAqgSAqgHIAGAnQglAGglARQhtAxgqBwQgrBwAyBuQAQAjAWAcIggAZQgZgggSgog");
	var mask_graphics_55 = new cjs.Graphics().p("AiRC+IABAAQg1h/A2h9QA1h/B+gzIAAAAQAqgRArgGIAEAoQglAFglAPQhvAugvBuQguBuAtBwQAPAjAVAdIggAZQgYgigRgog");
	var mask_graphics_56 = new cjs.Graphics().p("AiVC4IAAABQgviBA5h8QA6h8CAgvIAAAAQArgPAqgEIADAnQglAEglAOQhxApgyBtQgzBsAqByQANAkAUAdIghAXQgXgigPgpg");
	var mask_graphics_57 = new cjs.Graphics().p("AiZCzIAAAAQgriDA+h5QA/h6CBgrIAAABQAsgOAqgDIACAoQglACgnANQhyAlg2BrQg2BqAlBzQAMAlATAeIgiAWQgVgjgOgpg");
	var mask_graphics_58 = new cjs.Graphics().p("AidCsIABABQgmiEBCh3QBCh4CDgmIABAAQAsgMAqgBIAAAoQglABgnALQhzAhg6BpQg6BoAhB0QALAlASAfIgjAVQgUgkgNgqg");
	var mask_graphics_59 = new cjs.Graphics().p("AjTDqIAAgBQhghhAAiIQAAiJBghgQBihgCGgBIAAAoQh2ABhWBVIABAAQhVBUAAB4QAAB4BVBVQBVBWB3AAQB4AABWhWQAbgbASgeIAjAUQgVAjgfAfIAAgBQhhBiiJAAQiHAAhihhg");
	var mask_graphics_60 = new cjs.Graphics().p("AAOFLQiIgFhdhlIAAAAQhehkAFiIQAFiJBkhdQBkhdCHAEIgBAoQh3gDhYBSIAAAAQhYBRgEB4QgEB4BSBYQBSBYB3AFQB4AEBZhTQAcgaATgeIAiAWQgWAiggAeIAAgBQhfBaiBAAIgNAAg");
	var mask_graphics_61 = new cjs.Graphics().p("AAGFKQiIgKhahnIAAgBQhZhnAJiIQAKiIBnhaQBnhZCHAJIgDAoQh3gIhaBPIAAAAQhbBOgIB4QgIB4BOBaQBQBcB2AIQB4AIBbhPQAdgZAVgdIAhAXQgYAhggAdIAAgBQheBSh5AAIgZgBg");
	var mask_graphics_62 = new cjs.Graphics().p("AgBFJQiJgOhWhrIAAAAQhWhrAPiHQAOiJBqhVQBrhWCGAOIgEAoQh3gMhdBLIAAAAQhdBMgNB3QgMB3BLBeQBMBeB3AMQB3ANBehMQAegZAVgcIAhAYQgZAggiAcIAAgBQhbBLhxAAQgTAAgSgCg");
	var mask_graphics_63 = new cjs.Graphics().p("AgJFIQiIgUhThtIABgBQhThtAUiHQATiHBthSQBthSCGASIgGAoQh2gQhgBIIABAAQhgBIgRB3QgRB3BJBgQBIBgB3ARQB2ARBhhJQAegXAWgcIAgAZQgaAggiAaIAAAAQhZBDhrAAQgYAAgYgDg");
	var mask_graphics_64 = new cjs.Graphics().p("AgRFGQiHgYhPhwIABgBQhPhwAYiGQAYiHBwhOQBwhOCFAXIgHAnQh1gUhjBFIABAAQhjBFgUB2QgVB2BEBiQBGBjB2AVQB1AVBjhFQAfgWAYgbIAeAaQgaAfgkAZIAAgBQhWA9hkAAQgeAAgegFg");
	var mask_graphics_65 = new cjs.Graphics().p("AgYFEQiGgdhLhzIAAAAQhKhzAciFQAdiGByhKQBzhLCEAcIgIAnQh0gYhlBBIAAABQhlBAgZB2QgZB1BCBlQBCBlB1AZQB0AZBmhCQAggVAYgZIAeAbQgcAdgkAYIAAAAQhUA2hdAAQgkAAgjgHg");
	var mask_graphics_66 = new cjs.Graphics().p("AggFBQiFghhGh2IAAAAQhGh2AhiEQAhiFB1hFQB2hHCCAhIgJAnQh1gdhmA+IABAAQhnA+gdB0QgeB0A+BnQA/BoB0AdQB0AdBng+QAhgUAZgZIAdAcQgdAdglAWIAAAAQhQAwhYAAQgoAAgqgKg");
	var mask_graphics_67 = new cjs.Graphics().p("AgnE+QiDgmhDh4IAAAAQhCh4AmiDQAmiEB3hBQB3hCCDAlIgLAmQh0gghoA6IABAAQhpA6ghBzQgiB0A6BpQA7BpBzAhQBzAiBqg7QAhgTAagYIAcAdQgeAcgmAVIAAAAQhNArhRAAQguAAgvgOg");
	var mask_graphics_68 = new cjs.Graphics().p("AgtE7QiDgrg+h6IAAAAQg+h7AriBQAqiCB6g+QB5g+CBAqIgMAmQhyglhrA3IABAAQhrA2glBzQgmByA3BrQA3BrByAmQBxAlBsg3QAigSAbgXIAaAeQgeAbgnAUIAAgBQhJAmhMAAQgzAAgzgRg");
	var mask_graphics_69 = new cjs.Graphics().p("Ag0E3QiBgvg6h8IABgBQg6h8AviAQAviAB7g6QB8g5B/AuIgNAlQhxgohsAzIAAAAQhsAygpBxQgqBxAzBtQAzBtBxApQBwApBtgzQAjgQAbgWIAaAfQggAZgnATIAAgBQhFAhhGAAQg5AAg4gVg");
	var mask_graphics_70 = new cjs.Graphics().p("Ag6EzQh/g0g2h+IABAAQg2h+A0h+QAziAB9g0QB+g2B+AzIgPAlQhvgthuAwIAAAAQhuAugtBvQguBwAvBuQAwBwBvAtQBuAtBvgwQAkgPAcgVIAZAgQghAYgoARIAAAAQhAAchBAAQg+AAg9gZg");
	var mask_graphics_71 = new cjs.Graphics().p("AhAEuQh9g4gxiAIAAAAQgxh/A4h9QA4h9B/gxQB/gwB8A2IgQAlQhugwhvArIAAAAQhwArgxBtQgxBvArBvQAsBxBtAxQBtAwBxgrQAjgOAdgUIAYAhQgiAXgoAQIAAgBQg8AYg8AAQhDAAhBgeg");
	var mask_graphics_72 = new cjs.Graphics().p("AhGEpQh7g8gtiBIABgBQgtiAA9h8QA8h7CAgsQCBgsB6A7IgRAkQhsg0hxAnIABAAQhyAng1BsQg1BtAoBwQAnBzBsA0QBrA1BygnQAkgNAegTIAWAhQgiAWgpAPIAAgBQg3AUg3AAQhIAAhGgjg");
	var mask_graphics_73 = new cjs.Graphics().p("AhLEkQh5hAgoiDIAAgBQgoiCBBh5QBAh5CCgnQCCgoB4BAIgSAjQhqg4hyAjIAAAAQhzAjg4BqQg5BrAjByQAkBzBqA5QBpA4BzgjQAlgMAegSIAVAjQgjAUgpANIAAAAQgzAQgxAAQhNAAhKgog");
	var mask_graphics_74 = new cjs.Graphics().p("AhREeQh3hEgjiFIAAAAQgjiDBEh3QBFh3CEgiQCDgkB2BEIgUAjQhog8h0AfIAAABQhzAeg8BoQg8BpAfBzQAfB1BoA8QBnA8B1gfQAlgLAfgRIATAjQgjAUgqALIAAAAQgtAMgsAAQhTAAhOgtg");
	var mask_graphics_75 = new cjs.Graphics().p("AhgEZQh0hJgfiGIAAAAQgeiFBIh0QBJh0CEgeQCFgfB0BIIgVAiQhmg/h2AbIABAAQh0AbhABlQhABnAbB0QAbB2BmBAQBlA/B2gbQAlgJAggQIASAkQgkASgqAKIAAAAQgoAJgnAAQhZAAhRgyg");
	var mask_graphics_76 = new cjs.Graphics().p("AhvESQhxhMgaiHIAAAAQgaiGBNhxQBMhyCFgaQCHgZBxBLIgXAhQhjhCh3AXIABAAQh1AXhDBjQhEBkAXB1QAXB3BkBDQBiBDB3gXQAmgIAggOIARAkQglARgqAJIAAgBQgjAHghAAQhfAAhVg5g");
	var mask_graphics_77 = new cjs.Graphics().p("Ah9EMQhvhRgViHIAAgBQgViGBRhvQBQhvCGgVQCHgVBuBQIgXAgQhhhGh3ATIAAAAQh1AThHBhQhHBiATB1QATB4BhBGQBhBHB2gTQAmgGAhgOIAQAlQgmAQgrAHIABgBQgdAFgcAAQhmAAhXg/g");
	var mask_graphics_78 = new cjs.Graphics().p("AiLEFQhshVgQiIIAAAAQgQiHBUhsQBUhsCGgQQCIgRBsBUIgZAfQhfhJh3APIAAAAQh2AOhKBfQhKBfAPB2QAOB4BfBKQBeBKB3gPQAmgFAigMIAOAlQgmAPgrAFIABAAQgXADgXAAQhsAAhahGg");
	var mask_graphics_79 = new cjs.Graphics().p("AiYD9QhphYgMiIIAAgBQgLiHBYhpQBYhpCGgLQCJgMBoBXIgaAfQhchNh4AKIABABQh3AKhNBcQhNBdAKB2QALB5BbBNQBcBNB4gLQAmgDAhgMIAOAnQgnAMgrAFIABgBIgiACQhzAAhchOg");
	var mask_graphics_80 = new cjs.Graphics().p("AilD2QhmhcgHiJIAAAAQgHiIBchmQBbhlCHgHQCJgHBmBbIgbAdQhahQh4AHIABAAQh3AGhQBZQhRBaAGB3QAGB5BZBQQBaBQB3gGQAngCAhgKIANAmQgnAMgsACIABAAIgVABQh7AAhehVg");
	var mask_graphics_81 = new cjs.Graphics().p("AA5FKQiIADhjhfQhihfgDiJIAAgBQgCiIBghiQBfhjCHgCQCJgCBiBeIgcAdQhWhTh5ACIABABQh3ABhUBXQhUBXACB3QADB5BWBTQBWBUB4gDQAmgBAjgJIAKAnQgnALgrABg");
	var mask_graphics_82 = new cjs.Graphics().p("AApFLIABgBQiJgChfhiQhfhjACiIIAAAAQADiJBjhfQBihfCHACQCJADBfBiIgdAbQhThWh5gCIABABQh3gDhWBUQhYBUgCB4QgCB4BUBWQBTBWB4ACQAmABAjgIIAJAnQgmAJgpAAIgEAAg");
	var mask_graphics_83 = new cjs.Graphics().p("AAaFKIAAAAQiIgHhchmQhchlAIiIIAAgBQAHiIBmhcQBmhcCHAIQCJAHBbBlIgeAbQhQhZh4gGIAAAAQh3gHhZBRQhaBRgGB4QgHB3BRBaQBQBZB4AGQAmACAjgHIAIAoQggAGgiAAIgRgBg");
	var mask_graphics_84 = new cjs.Graphics().p("AAKFKIABgBQiIgLhYhpQhYhpAMiIIAAAAQAMiIBphZQBphYCHANQCIAMBYBoIgfAZQhNhbh4gLIAAABQh2gLhcBNQhdBOgKB4QgLB3BNBcQBNBcB4AKQAmADAjgFIAHAoQgaAEgbAAIgfgBg");
	var mask_graphics_85 = new cjs.Graphics().p("AgEFIIABAAQiJgQhUhsQhUhsAQiHIABgBQARiHBshVQBshUCGARQCIARBUBrIggAYQhKheh4gPIABABQh2gPhfBKQhfBKgPB4QgOB3BJBeQBKBfB3AOQAmAFAjgEIAGAoQgUACgUAAQgWAAgVgDg");
	var mask_graphics_86 = new cjs.Graphics().p("AgSFHIAAAAQiIgWhQhuQhRhvAViHIABAAQAWiHBuhRQBvhQCGAVQCHAWBQBuIggAXQhHhgh3gTIAAAAQh1gThhBHQhiBHgTB3QgTB2BHBhQBGBhB4ATQAlAGAjgDIAEAoIgcABQgbAAgbgEg");
	var mask_graphics_87 = new cjs.Graphics().p("AghFFIAAAAQiHgahMhyQhNhxAaiGIABAAQAaiHByhMQBxhNCFAaQCGAbBMBwIghAXQhDhjh2gXIAAAAQh1gXhjBDQhkBEgXB2QgXB1BDBkQBDBjB3AXQAkAHAkgBIACAoIgPAAQgiAAghgGg");
	var mask_graphics_88 = new cjs.Graphics().p("AgvFCIAAAAQiGgehJh1QhIh0AfiEIAAgBQAfiFB0hJQB0hICEAfQCFAfBJBzIgiAVQhAhlh1gbIAAAAQh0gbhmA/QhmBBgbB1QgbB0A/BmQBABmB2AbQAlAIAiAAIABAoIgDAAQgmAAgogJg");
	var mask_graphics_89 = new cjs.Graphics().p("Ag+FAIABgBQiFgjhFh2QhEh3AjiEIABAAQAkiEB2hEQB3hFCCAkQCFAjBEB2IgjAUQg8hoh0gfIAAABQhzgghoA8QhpA9gfB0QgfB0A8BoQA8BnB1AgQAlAJAiABIAAApQgogBgqgLg");
	var mask_graphics_90 = new cjs.Graphics().p("AhLE9IAAgBQiEgnhAh5QhAh5AoiDIAAAAQApiCB5hBQB5hACBAoQCDAoBAB4IgkATQg4hqhzgjIAAABQhygkhqA5QhrA4gjBzQgjBzA4BqQA5BqBzAjQAlALAiACIgBAoQgogCgpgMg");
	var mask_graphics_91 = new cjs.Graphics().p("AhZE6IAAgBQiCgsg8h7Qg8h7AtiBIAAAAQAtiCB7g8QB7g8CAAtQCBAtA8B6IgkARQg1hrhxgnIAAAAQhwgnhsA0QhtA1gnByQgnBxA0BsQA1BsByAnQAkANAkADIgEAoQgogEgpgNg");
	var mask_graphics_92 = new cjs.Graphics().p("AhmE2IAAAAQiAgxg4h9Qg4h9Axh/IABgBQAxh/B9g4QB8g4B/AxQCAAyA4B8IglAQQgxhthwgrIAAAAQhwgrhsAxQhvAxgrBwQgrBwAwBuQAxBtBxAsQAkANAjAEIgFApQgogGgogPg");
	var mask_graphics_93 = new cjs.Graphics().p("AhzEzIAAgBQh/g1gzh/Qgzh+A1h+IABgBQA2h9B/g0QB+gzB9A2QB+A1AzB+IglAPQgthvhvgvIAAABQhugwhuAtQhxAugvBuQgvBvAtBvQAtBvBvAvQAkAPAjAGIgGAoQgogHgogQg");
	var mask_graphics_94 = new cjs.Graphics().p("AiAEvIAAAAQh8g6gviBQgviAA6h8IAAAAQA7h8CAgvQCAgvB7A6QB8A6AvCAIglAOQgqhxhtgzIAAABQhsgzhwApQhyApgzBtQgzBuApBvQApBxBuAzQAjAQAjAHIgIAoQgogIgngSg");
	var mask_graphics_95 = new cjs.Graphics().p("AiMErIAAAAQh7g+gqiDQgqiBA+h6IABAAQA+h6CCgqQCCgrB5A+QB6A/AqCBIgmAMQglhyhsg2IAAAAQhqg2hxAlQhzAlg3BrQg3BsAlBxQAlByBsA3QAiARAjAIIgJAoQgogKgmgTg");
	var mask_graphics_96 = new cjs.Graphics().p("AiYEnIAAAAQh4hDgmiDQgmiDBDh4IAAAAQBDh4CEgmQCCglB3BCQB4BDAmCCIgnALQghhzhqg6IABAAQhpg6hyAhQh1Ahg6BpQg7BqAhBzQAiBzBpA7QAiASAiAJIgKAnQgngLgmgUg");
	var mask_graphics_97 = new cjs.Graphics().p("AikEiIABAAQh2hGgiiFQghiEBHh2IAAAAQBHh1CFghQCEghB1BGQB1BHAhCEIgnAKQgdh1hng+IAAABQhng+hzAdQh2Adg9BnQg/BoAdBzQAdB1BoA+QAhATAiALIgMAnQgngNglgWg");
	var mask_graphics_98 = new cjs.Graphics().p("AivEeIABAAQh0hLgciGQgdiFBLhzIAAAAQBLhyCGgdQCFgcByBKQBzBLAcCFIgnAIQgZh1hlhCIAAABQhkhCh1AZQh2AZhBBlQhCBmAZB0QAZB1BlBCQAgAVAiAMIgNAmQgngOgkgXg");
	var mask_graphics_99 = new cjs.Graphics().p("Ai6EZIABAAQhxhOgYiHQgYiGBPhwIABgBQBOhvCHgYQCGgYBvBOQBwBPAYCGIgnAHQgVh2hjhFIAAAAQhihFh1AVQh3AVhFBjQhFBjAVB1QAUB2BjBFQAgAWAhANIgOAmQgmgPgkgZg");
	var mask_graphics_100 = new cjs.Graphics().p("AjEEVIAAAAQhuhTgTiIQgTiGBThuIAAAAQBThtCIgTQCGgTBtBSQBtBTATCGIgnAGQgRh3hhhIIABAAQhghIh2ARQh4AQhIBgQhJBhARB2QARB3BgBIQAfAXAgAOIgPAmQglgRgjgZg");
	var mask_graphics_101 = new cjs.Graphics().p("AjOEQIABAAQhshXgOiIQgOiHBWhrIABAAQBWhqCIgOQCIgOBpBVQBqBXAPCHIgoAEQgNh3hdhMIAAABQhdhMh3ANQh4AMhMBeQhMBeANB2QAMB3BeBMQAeAYAgAPIgQAlQglgRgigbg");
	var mask_graphics_102 = new cjs.Graphics().p("AjXELIAAAAQhohagJiJQgKiIBahnIAAAAQBbhnCIgKQCIgJBmBZQBoBaAJCIIgoADQgIh4hbhPIAAABQhahPh3AIQh5AJhPBaQhPBcAIB2QAJB4BbBPQAdAZAgARIgSAkQglgTgggcg");
	var mask_graphics_103 = new cjs.Graphics().p("AjgEGIAAAAQhlhegEiJQgFiIBdhkIABAAQBdhkCJgFQCIgEBkBdQBkBdAFCHIgoACQgFh3hYhSIAAAAQhXhSh3AEQh5AFhSBXQhTBZAFB3QAEB4BYBSQAcAaAfARIgTAkQgjgUgggdg");
	var mask_graphics_104 = new cjs.Graphics().p("AjpEBIABAAQhihhAAiJQAAiIBhhhIABAAQBhhhCIAAQCJAABgBhQBgBhABCHIgoAAQgBh3hVhVIAAAAQhUhVh4AAQh4AAhVBVQhWBWAAB3QAAB4BWBVQAbAbAeASIgUAjQgjgVgfgeg");
	var mask_graphics_105 = new cjs.Graphics().p("AjxD7IABAAQhehkAEiJQAFiIBlhdIAAAAQBkheCIAFQCJAFBdBkQBdBkgECHIgogBQADh3hShYIAAAAQhRhYh4gEQh4gEhYBSQhYBSgFB3QgEB4BTBZQAaAcAeATIgWAiQgigWgeggg");
	var mask_graphics_106 = new cjs.Graphics().p("Aj5D2IABAAQhbhoAKiIQAKiIBnhaIABAAQBnhZCIAJQCIAKBaBnQBZBngJCHIgogDQAIh3hPhaIAAAAQhOhbh4gIQh4gIhaBOQhcBQgIB2QgIB4BPBbQAZAdAdAVIgXAhQghgYgdggg");
	var mask_graphics_107 = new cjs.Graphics().p("AkADwIABAAQhXhqAOiHQAOiJBrhWIAAAAQBrhWCHAPQCJAOBVBqQBWBrgOCGIgogEQAMh3hLhdIAAAAQhMhdh3gNQh3gMheBLQheBMgMB3QgNB3BMBeQAZAeAcAVIgYAhQgggZgcgig");
	var mask_graphics_108 = new cjs.Graphics().p("AkHDrIAAAAQhThuATiGQAUiIBthTIABABQBthTCHAUQCHATBSBtQBSBtgSCGIgogGQAQh2hIhgIAAABQhIhgh3gRQh3gRhgBJQhgBIgRB3QgRB2BJBhQAXAeAcAWIgZAgQgggagagig");
	var mask_graphics_109 = new cjs.Graphics().p("AkODlIABAAQhQhwAYiGQAYiHBwhPIABABQBwhPCGAYQCHAYBOBwQBOBwgXCFIgngHQAUh1hFhjIAAABQhFhjh2gUQh2gVhiBEQhjBGgVB2QgVB1BFBjQAWAfAbAYIgaAeQgfgagZgkg");
	var mask_graphics_110 = new cjs.Graphics().p("AkUDgIAAAAQhLhzAciFQAdiGBzhLIABAAQByhKCFAcQCGAdBKByQBLBzgcCEIgngIQAYh0hBhlIgBAAQhAhlh2gZQh1gZhlBCQhlBCgZB1QgZB0BCBmQAVAgAZAYIgbAeQgdgcgYgkg");
	var mask_graphics_111 = new cjs.Graphics().p("AkaDaIAAAAQhHh2AhiEQAhiFB2hGIAAAAQB2hGCEAhQCFAhBFB1QBHB2ghCCIgngJQAdh1g+hmIAAABQg+hnh0gdQh0gehnA+QhoA/gdB0QgdB0A+BnQAUAhAZAZIgcAdQgdgdgWglg");
	var mask_graphics_112 = new cjs.Graphics().p("AkgDUIAAAAQhDh4AmiDQAmiDB4hDIAAAAQB4hCCDAmQCEAmBBB3QBCB3glCDIgmgLQAgh0g6hoIAAABQg6hphzghQh0gihpA6QhpA7ghBzQgiBzA7BqQATAhAYAaIgdAcQgcgegVgmg");
	var mask_graphics_113 = new cjs.Graphics().p("AkmDOIABAAQg/h6AqiBQAriDB6g+IAAAAQB7g+CBArQCCAqA+B6QA+B5gqCBIgmgMQAlhyg3hrIAAABQg2hrhzglQhygmhrA3QhrA3gmByQglBxA3BsQASAiAXAbIgeAaQgbgegUgng");
	var mask_graphics_114 = new cjs.Graphics().p("AkrDIIABAAQg7h8AviAQAviBB8g6IABABQB8g6CAAvQCAAvA6B7QA5B8guB/IglgNQAohxgzhsIAAAAQgyhshxgpQhxgqhtAzQhtAzgpBxQgpBwAzBtQAQAjAWAbIgfAaQgZgggTgng");
	var mask_graphics_115 = new cjs.Graphics().p("AkvDCIAAAAQg2h+Azh+QA0h/B+g2IAAABQB+g2B+A0QCAAzA0B9QA2B+gzB+IglgPQAthvgwhuIAAAAQguhuhvgtQhwguhuAvQhwAwgtBvQgtBuAwBvQAPAkAVAcIggAZQgYghgRgog");
	var mask_graphics_116 = new cjs.Graphics().p("Ak0C8IABAAQgyiAA4h8QA4h9CAgxIAAAAQB/gxB9A4QB9A4AxB/QAwB/g2B8IglgQQAwhugrhvIAAAAQgrhwhtgxQhvgxhvArQhxAsgxBtQgwBtArBxQAOAjAUAdIghAYQgXgigQgog");
	var mask_graphics_117 = new cjs.Graphics().p("Ak4C2IABAAQgtiCA8h6QA8h7CBgtIABABQCAgtB8A9QB7A8AsCAQAsCBg7B6IgkgRQA0hsgnhxIAAABQgnhyhsg1Qhtg1hwAoQhzAng0BsQg1BrAnByQANAkATAeIghAWQgWgigPgpg");
	var mask_graphics_118 = new cjs.Graphics().p("Ak7CwIAAAAQgoiDBAh4QBAh5CDgoIABAAQCCgoB5BBQB5BAAnCCQAoCChAB4IgjgSQA4hqgjhyIAAAAQgjhzhqg4Qhrg5hyAjQhzAkg5BqQg4BpAjBzQAMAlASAeIgjAVQgUgjgNgpg");
	var mask_graphics_119 = new cjs.Graphics().p("AD8DkQA8hogfh0IgBAAQgehzhog8Qhpg8hzAfQh1Afg8BoQg8BnAfB1QALAlARAfIgjATQgUgjgLgqIAAAAQgkiEBFh2QBEh3CFgjIAAAAQCDgjB3BEQB3BFAiCEQAkCDhEB2g");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:-1.125,y:19.825}).wait(1).to({graphics:mask_graphics_1,x:-1.7206,y:19.8265}).wait(1).to({graphics:mask_graphics_2,x:-2.3153,y:19.8304}).wait(1).to({graphics:mask_graphics_3,x:-2.9084,y:19.836}).wait(1).to({graphics:mask_graphics_4,x:-3.4991,y:19.8423}).wait(1).to({graphics:mask_graphics_5,x:-4.0866,y:19.8489}).wait(1).to({graphics:mask_graphics_6,x:-4.6703,y:19.8551}).wait(1).to({graphics:mask_graphics_7,x:-5.2494,y:19.8605}).wait(1).to({graphics:mask_graphics_8,x:-5.823,y:19.8648}).wait(1).to({graphics:mask_graphics_9,x:-6.3906,y:19.8677}).wait(1).to({graphics:mask_graphics_10,x:-6.9513,y:19.869}).wait(1).to({graphics:mask_graphics_11,x:-7.5044,y:19.8686}).wait(1).to({graphics:mask_graphics_12,x:-8.0493,y:19.8664}).wait(1).to({graphics:mask_graphics_13,x:-8.5852,y:19.8626}).wait(1).to({graphics:mask_graphics_14,x:-9.1114,y:19.8573}).wait(1).to({graphics:mask_graphics_15,x:-9.628,y:19.8506}).wait(1).to({graphics:mask_graphics_16,x:-10.1485,y:19.8428}).wait(1).to({graphics:mask_graphics_17,x:-10.6779,y:19.8344}).wait(1).to({graphics:mask_graphics_18,x:-11.2161,y:19.8258}).wait(1).to({graphics:mask_graphics_19,x:-11.7629,y:19.8175}).wait(1).to({graphics:mask_graphics_20,x:-12.3182,y:19.8103}).wait(1).to({graphics:mask_graphics_21,x:-12.89,y:19.2721}).wait(1).to({graphics:mask_graphics_22,x:-13.472,y:18.7066}).wait(1).to({graphics:mask_graphics_23,x:-14.052,y:18.1348}).wait(1).to({graphics:mask_graphics_24,x:-14.6391,y:17.5734}).wait(1).to({graphics:mask_graphics_25,x:-15.2317,y:17.0224}).wait(1).to({graphics:mask_graphics_26,x:-15.8284,y:16.4818}).wait(1).to({graphics:mask_graphics_27,x:-16.4276,y:15.9516}).wait(1).to({graphics:mask_graphics_28,x:-17.0281,y:15.4317}).wait(1).to({graphics:mask_graphics_29,x:-17.1179,y:14.92}).wait(1).to({graphics:mask_graphics_30,x:-17.1235,y:14.4003}).wait(1).to({graphics:mask_graphics_31,x:-17.1278,y:13.8705}).wait(1).to({graphics:mask_graphics_32,x:-17.1305,y:13.3314}).wait(1).to({graphics:mask_graphics_33,x:-17.1316,y:12.7836}).wait(1).to({graphics:mask_graphics_34,x:-17.1311,y:12.2277}).wait(1).to({graphics:mask_graphics_35,x:-17.1289,y:11.6646}).wait(1).to({graphics:mask_graphics_36,x:-17.1252,y:11.0949}).wait(1).to({graphics:mask_graphics_37,x:-17.1202,y:10.5194}).wait(1).to({graphics:mask_graphics_38,x:-17.1141,y:9.9388}).wait(1).to({graphics:mask_graphics_39,x:-17.1074,y:9.3539}).wait(1).to({graphics:mask_graphics_40,x:-17.1005,y:8.7653}).wait(1).to({graphics:mask_graphics_41,x:-17.094,y:8.1739}).wait(1).to({graphics:mask_graphics_42,x:-17.0885,y:7.5804}).wait(1).to({graphics:mask_graphics_43,x:-17.0848,y:6.9856}).wait(1).to({graphics:mask_graphics_44,x:-17.0838,y:6.3903}).wait(1).to({graphics:mask_graphics_45,x:-17.0859,y:5.7951}).wait(1).to({graphics:mask_graphics_46,x:-17.0904,y:5.2009}).wait(1).to({graphics:mask_graphics_47,x:-17.0964,y:4.6084}).wait(1).to({graphics:mask_graphics_48,x:-17.1031,y:4.0184}).wait(1).to({graphics:mask_graphics_49,x:-17.1099,y:3.4316}).wait(1).to({graphics:mask_graphics_50,x:-17.1162,y:2.8488}).wait(1).to({graphics:mask_graphics_51,x:-17.1218,y:2.2708}).wait(1).to({graphics:mask_graphics_52,x:-17.1262,y:1.6983}).wait(1).to({graphics:mask_graphics_53,x:-17.1291,y:1.1319}).wait(1).to({graphics:mask_graphics_54,x:-17.1304,y:0.5725}).wait(1).to({graphics:mask_graphics_55,x:-17.13,y:0.0208}).wait(1).to({graphics:mask_graphics_56,x:-17.1279,y:-0.5226}).wait(1).to({graphics:mask_graphics_57,x:-17.1242,y:-1.0569}).wait(1).to({graphics:mask_graphics_58,x:-17.1067,y:-1.6252}).wait(1).to({graphics:mask_graphics_59,x:-3.3,y:6.575}).wait(1).to({graphics:mask_graphics_60,x:-3.6035,y:6.5749}).wait(1).to({graphics:mask_graphics_61,x:-3.9266,y:6.575}).wait(1).to({graphics:mask_graphics_62,x:-4.2681,y:6.575}).wait(1).to({graphics:mask_graphics_63,x:-4.6269,y:6.5749}).wait(1).to({graphics:mask_graphics_64,x:-5.0019,y:6.5748}).wait(1).to({graphics:mask_graphics_65,x:-5.3923,y:6.5746}).wait(1).to({graphics:mask_graphics_66,x:-5.7969,y:6.5744}).wait(1).to({graphics:mask_graphics_67,x:-6.2152,y:6.574}).wait(1).to({graphics:mask_graphics_68,x:-6.6461,y:6.5736}).wait(1).to({graphics:mask_graphics_69,x:-7.0892,y:6.573}).wait(1).to({graphics:mask_graphics_70,x:-7.5436,y:6.5723}).wait(1).to({graphics:mask_graphics_71,x:-8.0088,y:6.5715}).wait(1).to({graphics:mask_graphics_72,x:-8.4842,y:6.5705}).wait(1).to({graphics:mask_graphics_73,x:-8.9693,y:6.5693}).wait(1).to({graphics:mask_graphics_74,x:-9.3946,y:6.5679}).wait(1).to({graphics:mask_graphics_75,x:-8.8939,y:6.5663}).wait(1).to({graphics:mask_graphics_76,x:-8.4032,y:6.5646}).wait(1).to({graphics:mask_graphics_77,x:-7.9234,y:6.5625}).wait(1).to({graphics:mask_graphics_78,x:-7.4555,y:6.5603}).wait(1).to({graphics:mask_graphics_79,x:-7.0007,y:6.5577}).wait(1).to({graphics:mask_graphics_80,x:-6.5602,y:6.5549}).wait(1).to({graphics:mask_graphics_81,x:-6.1505,y:6.5658}).wait(1).to({graphics:mask_graphics_82,x:-5.7444,y:6.5645}).wait(1).to({graphics:mask_graphics_83,x:-5.3527,y:6.5581}).wait(1).to({graphics:mask_graphics_84,x:-4.978,y:6.5534}).wait(1).to({graphics:mask_graphics_85,x:-4.6201,y:6.5502}).wait(1).to({graphics:mask_graphics_86,x:-4.2787,y:6.5485}).wait(1).to({graphics:mask_graphics_87,x:-3.9537,y:6.5483}).wait(1).to({graphics:mask_graphics_88,x:-3.6449,y:6.5495}).wait(1).to({graphics:mask_graphics_89,x:-3.3524,y:6.5471}).wait(1).to({graphics:mask_graphics_90,x:-3.0763,y:6.5267}).wait(1).to({graphics:mask_graphics_91,x:-2.8166,y:6.4877}).wait(1).to({graphics:mask_graphics_92,x:-2.5734,y:6.4302}).wait(1).to({graphics:mask_graphics_93,x:-2.3471,y:6.3543}).wait(1).to({graphics:mask_graphics_94,x:-2.1378,y:6.2602}).wait(1).to({graphics:mask_graphics_95,x:-1.9459,y:6.1479}).wait(1).to({graphics:mask_graphics_96,x:-1.7716,y:6.0174}).wait(1).to({graphics:mask_graphics_97,x:-1.6155,y:5.8686}).wait(1).to({graphics:mask_graphics_98,x:-1.478,y:5.7015}).wait(1).to({graphics:mask_graphics_99,x:-1.3595,y:5.5158}).wait(1).to({graphics:mask_graphics_100,x:-1.2606,y:5.3115}).wait(1).to({graphics:mask_graphics_101,x:-1.182,y:5.0881}).wait(1).to({graphics:mask_graphics_102,x:-1.1243,y:4.8454}).wait(1).to({graphics:mask_graphics_103,x:-1.0884,y:4.5829}).wait(1).to({graphics:mask_graphics_104,x:-1.075,y:4.3}).wait(1).to({graphics:mask_graphics_105,x:-1.0749,y:3.9965}).wait(1).to({graphics:mask_graphics_106,x:-1.075,y:3.6734}).wait(1).to({graphics:mask_graphics_107,x:-1.075,y:3.3319}).wait(1).to({graphics:mask_graphics_108,x:-1.0749,y:2.9731}).wait(1).to({graphics:mask_graphics_109,x:-1.0748,y:2.5981}).wait(1).to({graphics:mask_graphics_110,x:-1.0746,y:2.2078}).wait(1).to({graphics:mask_graphics_111,x:-1.0744,y:1.8031}).wait(1).to({graphics:mask_graphics_112,x:-1.074,y:1.3849}).wait(1).to({graphics:mask_graphics_113,x:-1.0736,y:0.9539}).wait(1).to({graphics:mask_graphics_114,x:-1.073,y:0.5109}).wait(1).to({graphics:mask_graphics_115,x:-1.0723,y:0.0564}).wait(1).to({graphics:mask_graphics_116,x:-1.0715,y:-0.4087}).wait(1).to({graphics:mask_graphics_117,x:-1.0705,y:-0.8842}).wait(1).to({graphics:mask_graphics_118,x:-1.0693,y:-1.3693}).wait(1).to({graphics:mask_graphics_119,x:-1.0679,y:-1.7946}).wait(1));

	// Layer_3
	this.instance = new lib.RingFill_RED();
	this.instance.setTransform(-1.05,-2);
	this.instance._off = true;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(88).to({_off:false},0).to({alpha:0},16).to({_off:true},1).wait(15));

	// RingFill copy 2
	this.instance_1 = new lib.RingFill_RED();
	this.instance_1.setTransform(-1.05,-2);

	this.instance_2 = new lib.Speedometer_RingFill();
	this.instance_2.setTransform(-33.55,-26,0.2389,0.2389);

	var maskedShapeInstanceList = [this.instance_1,this.instance_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1,p:{alpha:1}}]}).to({state:[{t:this.instance_2}]},88).to({state:[{t:this.instance_2},{t:this.instance_1,p:{alpha:0}}]},31).wait(1));

	// RingBG
	this.instance_3 = new lib.Speedometer_RingBG();
	this.instance_3.setTransform(-33.55,-26,0.2389,0.2389);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(120));

	// BG
	this.instance_4 = new lib.Speedometer_Background();
	this.instance_4.setTransform(-31.95,-24.6,0.2389,0.2389);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(120));

	// Indicators
	this.instance_5 = new lib.Speedometer_Increments();
	this.instance_5.setTransform(-26.95,-23.6,0.2389,0.2389);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(120));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.1,-26.5,66.1,66.2);


(lib.ProgressIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Progress_Finish();
	this.instance.setTransform(165.85,29.75,0.3809,0.3816);

	this.bar = new lib.RoadProgressBar();
	this.bar.name = "bar";
	this.bar.setTransform(95.05,37.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bar},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressIndicator, new cjs.Rectangle(-149.9,4.5,323.8,77.9), null);


(lib.FinishMovieclip = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.finish = new lib.Finish();
	this.finish.name = "finish";
	this.finish.setTransform(0,84);

	this.timeline.addTween(cjs.Tween.get(this.finish).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FinishMovieclip, new cjs.Rectangle(-536.1,-110.7,1074.7,556.4), null);


(lib.CountdownSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// 3
	this.count3 = new lib.Countdown3();
	this.count3.name = "count3";
	this.count3.setTransform(0,84);

	this.timeline.addTween(cjs.Tween.get(this.count3).wait(1));

	// 2
	this.count2 = new lib.Countdown2();
	this.count2.name = "count2";
	this.count2.setTransform(0,144.2,1,1,0,0,0,0,60.2);

	this.timeline.addTween(cjs.Tween.get(this.count2).wait(1));

	// 1
	this.count1 = new lib.Countdown1();
	this.count1.name = "count1";
	this.count1.setTransform(0,106.1,1,1,0,0,0,0,22.1);

	this.timeline.addTween(cjs.Tween.get(this.count1).wait(1));

	// 0
	this.count0 = new lib.Countdown0();
	this.count0.name = "count0";
	this.count0.setTransform(0,84);

	this.timeline.addTween(cjs.Tween.get(this.count0).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CountdownSkin, new cjs.Rectangle(-350,-364.1,726.2,1216.5), null);


(lib.ConfettiLayers = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.confetti1 = new lib.Confetti1();
	this.confetti1.name = "confetti1";
	this.confetti1.setTransform(0,-4.5);

	this.timeline.addTween(cjs.Tween.get(this.confetti1).wait(1));

	// Layer_2
	this.confetti2 = new lib.Confetti2();
	this.confetti2.name = "confetti2";
	this.confetti2.setTransform(-3,0);

	this.timeline.addTween(cjs.Tween.get(this.confetti2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConfettiLayers, new cjs.Rectangle(-869.5,-3294,1739,3294), null);


(lib.CarTopview = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Gas
	this.gas = new lib.Gas_1();
	this.gas.name = "gas";
	this.gas.setTransform(-1.45,241.2,1,1,0,0,0,-4,-116);

	this.timeline.addTween(cjs.Tween.get(this.gas).wait(1));

	// car and shadow BITMAPS
	this.instance = new lib.Hud_1();
	this.instance.setTransform(-121.45,-52.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CarTopview, new cjs.Rectangle(-207.3,-52.7,398.6,828.2), null);


(lib.CarSpeedLines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// left
	this.wooshLB = new lib.Woosh_Animation();
	this.wooshLB.name = "wooshLB";
	this.wooshLB.setTransform(-205.15,212.7,1,1,0,0,180);

	this.wooshLF = new lib.Woosh_Animation();
	this.wooshLF.name = "wooshLF";
	this.wooshLF.setTransform(-186.85,11.65,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.wooshLF},{t:this.wooshLB}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CarSpeedLines, new cjs.Rectangle(-353.6,-91.3,315.3,407), null);


(lib.Hud = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// HUD elements
	this.speedometer = new lib.Speedometer();
	this.speedometer.name = "speedometer";
	this.speedometer.setTransform(3,-528.6,5.3062,5.304,0,0,0,0.1,-0.1);

	this.progressBar = new lib.ProgressIndicator();
	this.progressBar.name = "progressBar";
	this.progressBar.setTransform(-232,-851.65,2.473,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.progressBar},{t:this.speedometer}]}).wait(1));

	// SpeedLabel BITMAPS
	this.speedLabelTextField = new cjs.Text("speed", "italic 40px 'Roboto'", "#FFFFFF");
	this.speedLabelTextField.name = "speedLabelTextField";
	this.speedLabelTextField.textAlign = "center";
	this.speedLabelTextField.lineHeight = 48;
	this.speedLabelTextField.lineWidth = 281;
	this.speedLabelTextField.parent = this;
	this.speedLabelTextField.setTransform(-3.1,-452.15);
ranj.TextOffsetFixer.fix(this.speedLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.speedLabelTextField).wait(1));

	// HUD texts
	this.timeLabelTextfield = new cjs.Text("Elapsed time:", "42px 'Roboto Medium'", "#FFFFFF");
	this.timeLabelTextfield.name = "timeLabelTextfield";
	this.timeLabelTextfield.lineHeight = 50;
	this.timeLabelTextfield.lineWidth = 298;
	this.timeLabelTextfield.parent = this;
	this.timeLabelTextfield.setTransform(-495.5,-804.95);
ranj.TextOffsetFixer.fix(this.timeLabelTextfield);

	this.timeTextfield = new cjs.Text("00:00.00", "65px 'Roboto Medium'", "#FFFFFF");
	this.timeTextfield.name = "timeTextfield";
	this.timeTextfield.lineHeight = 78;
	this.timeTextfield.lineWidth = 294;
	this.timeTextfield.parent = this;
	this.timeTextfield.setTransform(-495.5,-744.55);
ranj.TextOffsetFixer.fix(this.timeTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.timeTextfield},{t:this.timeLabelTextfield}]}).wait(1));

	// HUD background
	this.instance = new lib.Dashboard();
	this.instance.setTransform(-676.05,-895.1,1.1817,1.1812);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Fade
	this.instance_1 = new lib.Fade_Topscreen();
	this.instance_1.setTransform(-693.4,-762.4,1.3917,1.0955);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hud, new cjs.Rectangle(-693.4,-895.1,1382,579.7), null);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// title
	this.titleTextfield = new cjs.Text("Minigame", "108px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 130;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-431.8,-765.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// text
	this.timeTextfield = new cjs.Text("Your time: \n01:24.33", "65px 'Roboto'", "#FFFFFF");
	this.timeTextfield.name = "timeTextfield";
	this.timeTextfield.lineHeight = 88;
	this.timeTextfield.lineWidth = 864;
	this.timeTextfield.parent = this;
	this.timeTextfield.setTransform(-427.8,-528.85);
ranj.TextOffsetFixer.fix(this.timeTextfield);

	this.bodyTextfield = new cjs.Text("Instructions here\nInstr ", "38px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 45;
	this.bodyTextfield.lineWidth = 866;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-427.8,-294.35);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bodyTextfield},{t:this.timeTextfield}]}).wait(1));

	// button
	this.button = new lib.StartGameButton_1();
	this.button.name = "button";
	this.button.setTransform(-19.25,691.35,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// Background
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-667.5,-1445,1746.9,2961), null);


(lib.FeedbackPopupBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bgRight = new lib.FeedbackPopupBG_Right();
	this.bgRight.name = "bgRight";
	this.bgRight.setTransform(200.5,37.5,1,1,0,0,0,25,37.5);

	this.bgMid = new lib.FeedbackPopupBG_Middle();
	this.bgMid.name = "bgMid";
	this.bgMid.setTransform(113,37.5,1,1,0,0,0,63,37.5);

	this.bgLeft = new lib.FeedbackPopupBG_Left();
	this.bgLeft.name = "bgLeft";
	this.bgLeft.setTransform(25.5,37.5,1,1,0,0,0,25,37.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bgLeft},{t:this.bgMid},{t:this.bgRight}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG, new cjs.Rectangle(0.5,0,225,75), null);


(lib.ReplayButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "18px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 22;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.45,-4.35);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "18px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 22;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.45,-4.35);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "18px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 22;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.45,-4.35);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "18px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 22;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.45,-4.35);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-64.55,25.45,0.5057,0.5057,180);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-64.55,25.45,0.5062,0.5062,180);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-64.55,25.45,0.5062,0.5062,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-103,-17.9,123.5,43.4);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton_1();
	this.instance.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_1 = new lib.PrevNextButton_down_1();
	this.instance_1.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_2 = new lib.PrevNextButton_disabled_1();
	this.instance_2.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea_1();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.NextButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton_1();
	this.instance.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_1 = new lib.PrevNextButton_down_1();
	this.instance_1.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_2 = new lib.PrevNextButton_disabled_1();
	this.instance_2.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea_1();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.TutorialStep0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.startButton = new lib.StartTutorialButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(-4.7,466.35,2.463,2.463);

	this.titleTextfield = new cjs.Text("Tijd om te oefenen", "74px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "center";
	this.titleTextfield.lineHeight = 89;
	this.titleTextfield.lineWidth = 673;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(0,-543.1021);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.bodyTextfield = new cjs.Text("• [Instructions]", "38px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 46;
	this.bodyTextfield.lineWidth = 619;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-309.25,-326.9521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.GatekeeperBackground();
	this.instance.setTransform(-0.05,-10.4,1,1,0,0,0,418.4,661);

	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(17.95,-4.4,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.overlay},{t:this.instance},{t:this.bodyTextfield},{t:this.titleTextfield},{t:this.startButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep0, new cjs.Rectangle(-672.8,-1079.1,1381.6,2149.3999999999996), null);


(lib.RoadContents = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// speedlines
	this.speedlines = new lib.CarSpeedLines();
	this.speedlines.name = "speedlines";
	this.speedlines.setTransform(-2,-360);

	this.timeline.addTween(cjs.Tween.get(this.speedlines).wait(1));

	// car
	this.car = new lib.CarTopview();
	this.car.name = "car";
	this.car.setTransform(-2,-360);

	this.timeline.addTween(cjs.Tween.get(this.car).wait(1));

	// dividers
	this.dividers = new lib.RoadDividerssidesonly();
	this.dividers.name = "dividers";
	this.dividers.setTransform(0,-770);

	this.timeline.addTween(cjs.Tween.get(this.dividers).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadContents, new cjs.Rectangle(-436.5,-1943.6,873,2359.1), null);


(lib.ProgressDots_MC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dot6 = new lib.ProgressDot_1();
	this.dot6.name = "dot6";
	this.dot6.setTransform(144,0);

	this.dot0 = new lib.ProgressDot_1();
	this.dot0.name = "dot0";
	this.dot0.setTransform(-144,0);

	this.dot1 = new lib.ProgressDot_1();
	this.dot1.name = "dot1";
	this.dot1.setTransform(-96,0);

	this.dot5 = new lib.ProgressDot_1();
	this.dot5.name = "dot5";
	this.dot5.setTransform(96,0);

	this.dot4 = new lib.ProgressDot_1();
	this.dot4.name = "dot4";
	this.dot4.setTransform(48,0);

	this.dot2 = new lib.ProgressDot_1();
	this.dot2.name = "dot2";
	this.dot2.setTransform(-48,0);

	this.dot3 = new lib.ProgressDot_1();
	this.dot3.name = "dot3";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dot3},{t:this.dot2},{t:this.dot4},{t:this.dot5},{t:this.dot1},{t:this.dot0},{t:this.dot6}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDots_MC, new cjs.Rectangle(-159,-15,318,30), null);


(lib.GatekeeperTutorialStep = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.titleTextfield = new cjs.Text("Screen title", "74px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "center";
	this.titleTextfield.lineHeight = 89;
	this.titleTextfield.lineWidth = 619;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(0.15,-543.1021);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.bodyTextfield = new cjs.Text("• [Instructions]", "38px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 46;
	this.bodyTextfield.lineWidth = 619;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-309.25,-326.9521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.replayButton = new lib.ReplayButton();
	this.replayButton.name = "replayButton";
	this.replayButton.setTransform(-240.05,554.55,2.1093,2.1093,0,0,0,-40.8,0.4);

	this.startButton = new lib.StartGameButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(182,569.25,2.4219,2.4219,0,0,0,0,3.5);

	this.instance = new lib.GatekeeperBackground();
	this.instance.setTransform(-1.05,-10.4,1,1,0,0,0,418.4,661);

	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(5.95,2.05,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.overlay},{t:this.instance},{t:this.startButton},{t:this.replayButton},{t:this.bodyTextfield},{t:this.titleTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GatekeeperTutorialStep, new cjs.Rectangle(-684.8,-1072.7,1381.6,2149.5), null);


(lib.GameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hud
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(-28.15,-606.5,1,1,0,0,0,-28.2,-606.5);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// bottom bar
	this.bottomBar = new lib.BottomBar();
	this.bottomBar.name = "bottomBar";
	this.bottomBar.setTransform(8.05,869.95,1,1,0,0,0,0,-125);

	this.timeline.addTween(cjs.Tween.get(this.bottomBar).wait(1));

	// confetti
	this.confetti = new lib.ConfettiLayers();
	this.confetti.name = "confetti";
	this.confetti.setTransform(8.95,-539);

	this.timeline.addTween(cjs.Tween.get(this.confetti).wait(1));

	// road
	this.road = new lib.RoadContents();
	this.road.name = "road";
	this.road.setTransform(-1.8,183.85,1,1,0,0,0,-1.8,-687.2);

	this.timeline.addTween(cjs.Tween.get(this.road).wait(1));

	// bg
	this.instance = new lib.Background_Grey();
	this.instance.setTransform(-667,-754.9,1.3655,0.8892);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenSkin, new cjs.Rectangle(-887.3,-3833,1966.7,5119.4), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "italic 40px 'Roboto'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 49;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-0.7498,9.8);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.bg = new lib.FeedbackPopupBG();
	this.bg.name = "bg";
	this.bg.setTransform(-2,34.25,1,1,0,0,0,112,37.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113.5,-3.2,225,78.4), null);


(lib.TutorialOverlaySkinOld = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {overlay1:0,overlay2:1,overlay3:2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Progress
	this.progressDots = new lib.ProgressDots_MC();
	this.progressDots.name = "progressDots";
	this.progressDots.setTransform(-0.45,822);

	this.timeline.addTween(cjs.Tween.get(this.progressDots).wait(3));

	// buttons next and prev
	this.prevButton = new lib.PrevButton();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(-240.05,324.3,3,3,0,0,0,-41,0.1);

	this.nextButton = new lib.NextButton();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(260.2,324.3,3,3,0,0,0,-38.7,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nextButton},{t:this.prevButton}]}).wait(3));

	// button start
	this.button = new lib.StartGameButton_Overlay();
	this.button.name = "button";
	this.button.setTransform(274.2,324,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(3));

	// Line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EggNBUNMAAAioZMBAbAAA");
	this.shape.setTransform(-244.8,85.725);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFFFF").ss(1,1,1).p("EArIgLVIAAWrMhWQAAA");
	this.shape_1.setTransform(-150.9,-331.25);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#FFFFFF").ss(1,1,1).p("EgOYBGRIAAJAEgvzBGRIAAJAEgOYBGRMghbAAAEBFrhPQMiLVAAAMAAACVhIV3AAEAUQBGRIAAJAEAUQBGRMAhgAAAIAAJAEAUQBGRMgioAAA");
	this.shape_2.setTransform(-8.075,-34.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).wait(1));

	// Titles
	this.title1Textfield = new cjs.Text("xCONTROLS", "20px 'Roboto Medium'", "#FFFFFF");
	this.title1Textfield.name = "title1Textfield";
	this.title1Textfield.lineHeight = 24;
	this.title1Textfield.lineWidth = 284;
	this.title1Textfield.parent = this;
	this.title1Textfield.setTransform(-420.95,-537.1,3,3);
ranj.TextOffsetFixer.fix(this.title1Textfield);

	this.timeline.addTween(cjs.Tween.get(this.title1Textfield).to({_off:true},1).wait(2));

	// Titles
	this.title3Textfield = new cjs.Text("xLANES", "20px 'Roboto Medium'", "#FFFFFF");
	this.title3Textfield.name = "title3Textfield";
	this.title3Textfield.lineHeight = 24;
	this.title3Textfield.lineWidth = 264;
	this.title3Textfield.parent = this;
	this.title3Textfield.setTransform(-426.2,-619.45,3,3);
	this.title3Textfield._off = true;
ranj.TextOffsetFixer.fix(this.title3Textfield);

	this.timeline.addTween(cjs.Tween.get(this.title3Textfield).wait(2).to({_off:false},0).wait(1));

	// Titles
	this.title2Textfield = new cjs.Text("xSNELHEIDSMETE", "20px 'Roboto Medium'", "#FFFFFF");
	this.title2Textfield.name = "title2Textfield";
	this.title2Textfield.lineHeight = 24;
	this.title2Textfield.lineWidth = 254;
	this.title2Textfield.parent = this;
	this.title2Textfield.setTransform(-426.2,-336.15,3,3);
	this.title2Textfield._off = true;
ranj.TextOffsetFixer.fix(this.title2Textfield);

	this.timeline.addTween(cjs.Tween.get(this.title2Textfield).wait(1).to({_off:false},0).to({_off:true},1).wait(1));

	// Text
	this.body1Textfield = new cjs.Text("• xYou control the red racing car\n\n• It is driving on a track with 4 different lanes\n\n• You switch lanes with your car by tapping on the lane you want to move to", "14px 'Roboto'", "#FFFFFF");
	this.body1Textfield.name = "body1Textfield";
	this.body1Textfield.lineHeight = 17;
	this.body1Textfield.lineWidth = 286;
	this.body1Textfield.parent = this;
	this.body1Textfield.setTransform(-420.95,-426.05,3,3);
ranj.TextOffsetFixer.fix(this.body1Textfield);

	this.timeline.addTween(cjs.Tween.get(this.body1Textfield).to({_off:true},1).wait(2));

	// Text
	this.body3Textfield = new cjs.Text("x[• Using your speed gauge, you have to determine which of the lanes is the fastest\n\n• To get to the finish in as little time as possible, always try to be on the fastest lane\n\n• Only one of the lanes will be the fastest one]", "14px 'Roboto'", "#FFFFFF");
	this.body3Textfield.name = "body3Textfield";
	this.body3Textfield.lineHeight = 17;
	this.body3Textfield.lineWidth = 286;
	this.body3Textfield.parent = this;
	this.body3Textfield.setTransform(-426.2,-513.8,3,3);
	this.body3Textfield._off = true;
ranj.TextOffsetFixer.fix(this.body3Textfield);

	this.timeline.addTween(cjs.Tween.get(this.body3Textfield).wait(2).to({_off:false},0).wait(1));

	// Text
	this.body2Textfield = new cjs.Text("x• Using your speed gauge, you have to determine which of the lanes is the \n\n• To get to the finish in as little time as possible, always try to be on the fastest\n\n• Only one of the lanes will be the fastest one", "14px 'Roboto'", "#FFFFFF");
	this.body2Textfield.name = "body2Textfield";
	this.body2Textfield.lineHeight = 17;
	this.body2Textfield.lineWidth = 286;
	this.body2Textfield.parent = this;
	this.body2Textfield.setTransform(-426.2,-226.1,3,3);
	this.body2Textfield._off = true;
ranj.TextOffsetFixer.fix(this.body2Textfield);

	this.timeline.addTween(cjs.Tween.get(this.body2Textfield).wait(1).to({_off:false},0).to({_off:true},1).wait(1));

	// BG
	this.bg1 = new lib.Overlay_Car_1();
	this.bg1.name = "bg1";
	this.bg1.setTransform(-347.3,-251.4,3,3,0,0,0,180,380.3);
	this.bg1.alpha = 0.9688;

	this.bg1_1 = new lib.Overlay_Speedometer_1();
	this.bg1_1.name = "bg1_1";
	this.bg1_1.setTransform(-361.4,49.1,3,3,0,0,0,180,380.3);
	this.bg1_1.alpha = 0.9688;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg1}]}).to({state:[{t:this.bg1_1}]},1).to({state:[{t:this.bg1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-901.4,-1392.3,1984.8000000000002,2944.3999999999996);


(lib.TutorialOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.step0 = new lib.TutorialStep0();
	this.step0.name = "step0";
	this.step0.setTransform(0,-0.1);

	this.step1 = new lib.TutorialStep1();
	this.step1.name = "step1";
	this.step1.setTransform(4.9,-191.9,1,1,0,0,0,-213.5,-981.9);

	this.step2 = new lib.TutorialStep2();
	this.step2.name = "step2";
	this.step2.setTransform(-80.55,164.85,1,1,0,0,0,1.3,1);

	this.step3 = new lib.TutorialStep3();
	this.step3.name = "step3";
	this.step3.setTransform(222.8,791,1,1,0,0,0,1.3,1);

	this.step4 = new lib.TutorialStep4();
	this.step4.name = "step4";
	this.step4.setTransform(-150.1,-122.6,1,1,0,0,0,1.3,1);

	this.step5 = new lib.TutorialStep5();
	this.step5.name = "step5";
	this.step5.setTransform(-60.45,-163.95,1,1,0,0,0,-0.1,20.2);

	this.step6 = new lib.EmptyTutorialStep();
	this.step6.name = "step6";
	this.step6.setTransform(-4.4,1.5);

	this.step7 = new lib.GatekeeperTutorialStep();
	this.step7.name = "step7";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.step0}]}).to({state:[{t:this.step1}]},1).to({state:[{t:this.step2}]},1).to({state:[{t:this.step3}]},1).to({state:[{t:this.step4}]},1).to({state:[{t:this.step5}]},1).to({state:[{t:this.step6}]},1).to({state:[{t:this.step7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-684.8,-1180.2,1768.2,2257);


// stage content:
(lib.MainAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// other
	this.feedbackPanel = new lib.FeedbackPanel();
	this.feedbackPanel.name = "feedbackPanel";
	this.feedbackPanel.setTransform(381.35,3050.6,1,1,0,0,0,-3.5,31.4);

	this.timeline.addTween(cjs.Tween.get(this.feedbackPanel).wait(1));

	// finish
	this.finishMc = new lib.FinishMovieclip();
	this.finishMc.name = "finishMc";
	this.finishMc.setTransform(540,871,1.0005,1.0005);

	this.timeline.addTween(cjs.Tween.get(this.finishMc).wait(1));

	// countdown
	this.instance = new lib.CountdownSkin();
	this.instance.setTransform(540,871);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// tutorial
	this.instance_1 = new lib.TutorialOverlaySkinOld();
	this.instance_1.setTransform(720,1251.3,1,1,0,0,0,180,380.3);
	this.instance_1.cache(-903,-1394,1989,2948);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// road assets
	this.instance_2 = new lib.ShapeDiamondSkin();
	this.instance_2.setTransform(-1282.15,2322.95);

	this.instance_3 = new lib.ShapeTriangleSkin();
	this.instance_3.setTransform(-1460.7,2312.45);

	this.instance_4 = new lib.ShapeStarSkin();
	this.instance_4.setTransform(-1641.35,2312.45);

	this.instance_5 = new lib.ShapeCircleSkin();
	this.instance_5.setTransform(-1825,2322.95);

	this.instance_6 = new lib.FinishTile();
	this.instance_6.setTransform(-255.5,3915.35);

	this.instance_7 = new lib.SectionDividerSkin();
	this.instance_7.setTransform(-775.3,2525.9);

	this.instance_8 = new lib.MarkerStart();
	this.instance_8.setTransform(374.35,2763.7,1,1,0,0,0,0,-20);

	this.instance_9 = new lib.RoadTileGrey();
	this.instance_9.setTransform(-811.3,3741.2);

	this.instance_10 = new lib.RoadTileDarkGrey();
	this.instance_10.setTransform(-474.15,3721.2,1,1,0,0,0,0,-20);

	this.instance_11 = new lib.RoadTileGreen();
	this.instance_11.setTransform(-1947.8,3721.3,1,1,0,0,0,0,-20);

	this.instance_12 = new lib.RoadTileBlue();
	this.instance_12.setTransform(-1731.8,3721.25,1,1,0,0,0,0,-20);

	this.instance_13 = new lib.RoadTileYellow();
	this.instance_13.setTransform(-1515.8,3721.3,1,1,0,0,0,0,-20);

	this.instance_14 = new lib.RoadTileBrown();
	this.instance_14.setTransform(-1299.8,3721.3,1,1,0,0,0,0,-20);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(1));

	// endscreen
	this.instance_15 = new lib.EndScreenSkin();
	this.instance_15.setTransform(1941.45,871);

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(1));

	// gamescreen
	this.instance_16 = new lib.GameScreenSkin();
	this.instance_16.setTransform(720,1191,1,1,0,0,0,180,320);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-1515.8,-2091,4124.4,6113.9);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/Background_Blue.png", id:"MainAssets_Background_Blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Background_Grey.png", id:"MainAssets_Background_Grey", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled.png", id:"MainAssets_Button_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled_1.png", id:"MainAssets_Button_disabled_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down.png", id:"MainAssets_Button_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down_1.png", id:"MainAssets_Button_down_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up.png", id:"MainAssets_Button_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up_1.png", id:"MainAssets_Button_up_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Confetti_1.png", id:"MainAssets_Confetti_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Confetti_2.png", id:"MainAssets_Confetti_2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dashboard.png", id:"MainAssets_Dashboard", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fade_Topscreen.png", id:"MainAssets_Fade_Topscreen", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Left.png", id:"MainAssets_FeedbackPopup_Left", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Middle.png", id:"MainAssets_FeedbackPopup_Middle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Right.png", id:"MainAssets_FeedbackPopup_Right", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Finishline.png", id:"MainAssets_Finishline", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Gas.png", id:"MainAssets_Gas", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gatekeeper.png", id:"MainAssets_gatekeeper", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Hud_1.png", id:"MainAssets_Hud_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Lane001.png", id:"MainAssets_Lane001", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Lane002.png", id:"MainAssets_Lane002", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Lane003.png", id:"MainAssets_Lane003", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Lane004.png", id:"MainAssets_Lane004", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LaneDividerLine.png", id:"MainAssets_LaneDividerLine", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/line1.png", id:"MainAssets_line1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MarkerStartBmp.png", id:"MainAssets_MarkerStartBmp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Overlay_Car.png", id:"MainAssets_Overlay_Car", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Overlay_Speedometer.png", id:"MainAssets_Overlay_Speedometer", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Pattern_02_1000px.png", id:"MainAssets_Pattern_02_1000px", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Pattern_04_1000px.png", id:"MainAssets_Pattern_04_1000px", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton.png", id:"MainAssets_PrevNextButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_1.png", id:"MainAssets_PrevNextButton_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_disabled.png", id:"MainAssets_PrevNextButton_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_disabled_1.png", id:"MainAssets_PrevNextButton_disabled_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_down.png", id:"MainAssets_PrevNextButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_down_1.png", id:"MainAssets_PrevNextButton_down_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Progress_Background.png", id:"MainAssets_Progress_Background", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Progress_Fill.png", id:"MainAssets_Progress_Fill", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Progress_Finish.png", id:"MainAssets_Progress_Finish", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot.png", id:"MainAssets_ProgressDot", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot_Selected.png", id:"MainAssets_ProgressDot_Selected", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Racing_Illustration.png", id:"MainAssets_Racing_Illustration", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ResponsivenessBottom.png", id:"MainAssets_ResponsivenessBottom", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ShapeCircle.png", id:"MainAssets_ShapeCircle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ShapeDiamond.png", id:"MainAssets_ShapeDiamond", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ShapeStar.png", id:"MainAssets_ShapeStar", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ShapeTriangle.png", id:"MainAssets_ShapeTriangle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_Arrow.png", id:"MainAssets_Speedometer_Arrow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_Background.png", id:"MainAssets_Speedometer_Background", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_Increments.png", id:"MainAssets_Speedometer_Increments", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_RingBG.png", id:"MainAssets_Speedometer_RingBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_RingFill.png", id:"MainAssets_Speedometer_RingFill", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_RingFill_Suboptimal.png", id:"MainAssets_Speedometer_RingFill_Suboptimal", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutNew01.png", id:"MainAssets_TutNew01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutNew02.png", id:"MainAssets_TutNew02", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00000.png", id:"MainAssets_Woosh_00000", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00001.png", id:"MainAssets_Woosh_00001", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00002.png", id:"MainAssets_Woosh_00002", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00003.png", id:"MainAssets_Woosh_00003", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00004.png", id:"MainAssets_Woosh_00004", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00005.png", id:"MainAssets_Woosh_00005", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00006.png", id:"MainAssets_Woosh_00006", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00007.png", id:"MainAssets_Woosh_00007", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00008.png", id:"MainAssets_Woosh_00008", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;